var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};
// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement("script");
  script.src = url;
  document.body.appendChild(script);
};

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: true,
        passive: isScrollEvent,
      });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: false,
        passive: isScrollEvent,
      });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent =
    ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !==
    -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, {
        capture: useCapture,
        passive: isScrollEvent,
      });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this.boundRunCallbacks = this.runCallbacks.bind(this);
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, {
        passive: true,
      });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key),
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener("scroll", this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach((callback) => callback());
  }
}

const scrollListener = new GlobalScrollListener();

class Responsive {
  constructor(enableGeneralBreakpointChange) {
    this.settings();

    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)",
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      lap: "(min-width: 1025px) and (max-width: 1279px)",
      desktop: "(min-width: 1280px)",
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
          new CustomEvent("breakpoint:changed", {
            detail: {
              previousBreakpoint: this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          })
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
          new CustomEvent(`breakpoint:${key}`, {
            detail: {
              matches: isCurrentlyInBreakpoint,
            },
          })
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      console.error("Breakpoint does not exist:", breakpoint);
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      console.warn("Listener already exists for breakpoint:", breakpoint);
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(false);

class Popup {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="open-modal"]',
      this.openModal.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-modal"]',
      this.closeModal.bind(this)
    );
    document.addEventListener(
      "posted_successfully",
      this.openModalSpecial.bind(this)
    );

    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openModal() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");

    this.activeModal = document.getElementById(
      event.target.getAttribute("aria-controls")
    );

    let headerElement = this.activeModal.querySelector(".popup-header__wrapper");
    let contentElement = this.activeModal.querySelector(".account--PopupContent");

    if (headerElement && contentElement) {
      let headerHeight = headerElement.offsetHeight;
      let remainingHeight = `calc(100% - ${headerHeight}px)`;
      contentElement.style.height = remainingHeight;
    }

    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.style.display = "block";
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    var focus = this.element.querySelector("[data-scrollable]");

    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");
  }
  openModalSpecial() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute("aria-hidden", "false");
    var focus = this.element.querySelector("[data-scrollable]");
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");
    trapFocus(this.activeModal);
  }
  closeModal(event) {
    this.activeModal = document.body.querySelector(
      '.Popup[aria-hidden="false"]'
    );

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );
    this.activeModal.setAttribute("aria-hidden", "true");

    bodyScrollLock.clearAllBodyScrollLocks();
    document.body.classList.remove("scrollLock");
    this.activeModal.removeAttribute("style");

    const form = this.activeModal.querySelector("form");
    if (form && event.target.getAttribute('data-action') === 'close-modal') {
      form.reset();
    }
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();
  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    responsive.addResizeListener(this, this.syncHeight.bind(this));
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );

  }


  photoswiperClose() {
    if (this.photoSwipeInstance) {
      this.photoSwipeInstance.close;
    }
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe() {

    var images = [],
      index = 0;
    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
      var index = this.slideshow.swiperElement.realIndex;
      this.slideshow.swiperElement.slides[index]
        .querySelector(".ProductSlider--Element")
        .getAttribute("data-image-position");
    } else {
      index = event.target.dataset.imagePosition;
      images = [...document.querySelectorAll(".ProductSlider--Image")];
    }


    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(index)
    );
  }



  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute("data-max-width")),
        maxHeight = parseInt(image.getAttribute("data-max-height")),
        maxDimension = responsive.matchesBreakpoint("phone") ? 1200 : 2200,
        reduceFactor = 1.0;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: image.dataset.originalSrc,
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {

    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
            ".mainSwiper .ProductSliderCell--Zoom img"
          ),
            thumbnail = allThumbnail[index],
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );
    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .removeAttribute("disabled");
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}


class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );
  }

  addToCart() {
    var _this = this;
    event.preventDefault();
    var addToCartButton = event.target;
    this.pageLoader.style.width = 100 + "%";
    addToCartButton.setAttribute("disabled", "disabled");
    var formElement = event.target.closest("form");
    formElement.querySelector('[name="id"]').removeAttribute("disabled");
    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);
    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (window.theme.cartMode === "page") {
          location.href = window.routes.cart_page_url;
        }
        if (window.location.href.indexOf("cart") != -1) {
          location.reload();
          return;
        }
        addToCartButton.removeAttribute("disabled");
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
            },
          })
        );
      } else {
        response.json().then(function (content) {
          if (addToCartButton.closest(".ProductForm--Error")) {
            addToCartButton.closest(".ProductForm--Error")
              .classList.add("visible");
            setTimeout(function () {
              addToCartButton.closest(".ProductForm--Error")
                .classList.remove("visible");
              addToCartButton.removeAttribute("disabled");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          } else {
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p4 accent";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.insertAdjacentElement(
              "afterend",
              errorMessageElement
            );
            if (addToCartButton.parentElement && addToCartButton.parentElement.classList.contains("product-form__sticky-payment")) {
              errorMessageElement.classList.add('is-sticky')
            }
            setTimeout(function () {
              errorMessageElement.remove();
              addToCartButton.removeAttribute("disabled");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          }
        });
      }
    });
  }
}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}


class RevolutionSelectbox {
  constructor(element, additionalOverlay) {
    this.element = element;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.isOpen = false;

    this.mainDropdown = this.element.querySelector(
      ".RevolutionSelectbox--Content"
    );

    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(
      ".RevolutionSelectbox--Button"
    );
    this.headerTransparent = document.body
      .querySelector("#header")
      .classList.contains("Header--Transparent")
      ? true
      : false;

    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
      "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }

    if (this.changeOverlay) {
      this.pageOverlayElement = document.querySelector(
        ".localizationOverlay"
      );
    } else {
      this.pageOverlayElement = document.querySelector(".pageOverlay");
    }

    this.bindEvents();
    this.initSelectbox();

  }

  bindEvents() {

    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on(
      "click",
      "[data-action=toggle-selectbox]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );

    this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
  }

  selectboxChange() {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    var innerContent = event.target.innerHTML;
    var selEl = this.element.querySelector("#" + selectboxID);
    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else {
      selEl
        .setAttribute("checked", "true");
    }

    if (this.mainButton) {
      this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
        innerContent;
    }


    if (this.element.classList.contains("dropdownSelector")) {
      this.element
        .querySelector('.RevolutionSelectbox--Item[disabled="true"]')
        .removeAttribute("disabled");
      event.target.setAttribute("disabled", "true");
    }

    if (event.target.dataset.selectboxid == 'country-selector__country-code') {
      this.element.dispatchEvent(
        new CustomEvent("change:countrySelector", {
          bubbles: true,
          detail: {
            currency: event.target.dataset.currency,
            country: event.target.value,
            languages: event.target.dataset.languages
          },
        })
      );

    }
    this.closeDropdown(this.element);
  }

  onClickOutside(event) {

    if (event.type == 'menu:open') {

      this.closeDropdown(this.element);
      return;
    }


    const withinBoundaries = event.composedPath().includes(this.element);

    if (
      !withinBoundaries
    ) {
      this.closeDropdown(this.element);
    }

  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.closest("[data-value]").getAttribute("data-value");
    var dataName = event.target
      .closest("[data-name]")
      .getAttribute("data-name");
    this.selectbox.value = value;

    this.element.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    const selectedItem = this.mainDropdown.querySelector(
      '[selected="selected"]'
    );
    const titleElement = this.element.querySelector(".RevolutionSelectbox--Title");

    if (selectedItem && titleElement) {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }

    trapFocus(this.element);
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();

    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.element.dispatchEvent(
        new CustomEvent("menu:close", { bubbles: true })
      );
    }


    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(
      target.parentElement.parentElement.children
    ).filter((item) => item.classList.contains("RevolutionSelectbox"));
    if (
      this.element.classList.contains("RevolutionSelectbox--Selectors") &&
      responsive.matchesBreakpoint("lap_and_up") &&
      this.headerTransparent
    ) {
      setTimeout(() => {
        document
          .querySelector("#header")
          .classList.remove("Header--Transparent");
      }, 1);
      setTimeout(() => {
        document
          .querySelector("#header")
          .classList.remove("Header--Transparent");
      }, 601);
    }
    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item
        .querySelector(".RevolutionSelectbox--Button")
        .setAttribute("aria-expanded", false);
      item
        .querySelector(".RevolutionSelectbox--Content")
        .setAttribute("aria-hidden", true);
      item.querySelector(".RevolutionSelectbox--Content").style.display =
        "none";
    });




    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector(
      ".RevolutionSelectbox--Content"
    );
    target.setAttribute("aria-expanded", "true");

    contentElement.style.display = "block";
    contentElement.style.height = `${contentElement.offsetHeight}px`;
    contentElement.offsetHeight;

    requestAnimationFrame(() => {
      contentElement.setAttribute("aria-hidden", "false");
    });


    this.isOpen = true;
    window.addEventListener("click", this.onClickOutsideListener);
  }

  closeDropdown(target) {
    if (this.changeOverlay) {
      var focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.enableBodyScroll(focus, bodyScrollLockOptions);
    }



    let closestDropdown = target.closest(".RevolutionSelectbox");
    if (closestDropdown === null) {
      closestDropdown = target.querySelector(
        "[aria-expanded='true']"
      ).parentElement;
    }
    closestDropdown
      .querySelector(".RevolutionSelectbox--Button")
      .setAttribute("aria-expanded", false);
    closestDropdown
      .querySelector(".RevolutionSelectbox--Content")
      .setAttribute("aria-hidden", true);
    setTimeout(() => {
      closestDropdown.querySelector(
        ".RevolutionSelectbox--Content"
      ).style.display = "none";
    }, 401);


    this.isOpen = false;
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);
  }
}

class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.dropdownButton = null;
    this.dropdownContent = null;
    const selectBox = this.element.querySelector(".RevolutionSelectbox");
    new RevolutionSelectbox(selectBox);



  }

  connectedCallback() {
    this.delegateBody = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    this.dropdownButton = this.querySelector(".localization-open.RevolutionSelectbox--Button");
    this.dropdownContent = this.querySelector(".language-dropdown");
    this.toggleDropdownListener = this.toggleDropdown.bind(this);
    this.delegateBody.on("change:countrySelector", this.updateLanguageOptions.bind(this));

    this.delegateBody.on(
      "click",
      ".close-localization",
      this.toggleDropdown.bind(this),
    )
    this.delegateBody.on(
      "click",
      ".localization-open",
      this.toggleDropdown.bind(this),

      true
    );

    this.delegateBody.on(
      "click",
      ".RevolutionSelectbox--Item",
      this.handleCountrySelect.bind(this),

      true
    );

    this.delegateBody.on(
      "change",
      ".language-selector__radio",
      this.handleLanguageChange.bind(this),

      true
    );

    this.handleOutsideClick = (event) => {
      const isExpanded = this.dropdownButton?.getAttribute("aria-expanded") === "true";
      const header = document.querySelector("#header");

      if (!this.contains(event.target) && isExpanded) {
        if (responsive.matchesBreakpoint("lap_and_up")) {
          // LAP AND UP: Close dropdown and restore transparency if needed
          this.dropdownButton.setAttribute("aria-expanded", "false");
          this.dropdownContent.setAttribute("aria-hidden", "true");

          if (JSON.parse(header.getAttribute("data-settings")).transparent) {
            header.classList.add("Header--Transparent");
          }

          // Remove event listener when dropdown closes
          document.body.classList.remove("scrollLock");
          bodyScrollLock.enableBodyScroll(this.element.querySelector('[data-scrollable]'));
          this.pageOverlayElement.removeAttribute('style');
          this.pageOverlayElement.removeEventListener("click", this.toggleDropdownListener);

        }
      }
    };


    this.delegateRoot.on(
      "menu:open",
      (e) => this.handleOutsideClick(e, e.target, true)
    );

  }

  handleLanguageChange(event) {
    const languageInput = this.element.querySelector("#selected-language");
    languageInput.value = event.target.value;
  }


  updateLanguageOptions(e) {
    const languagesJSON = e.detail.languages;
    const languages = JSON.parse(languagesJSON);

    const languageOptionsContainer = document.querySelector(".language-options");
    const selectedLanguageInput = document.querySelector("#selected-language");
    if (!languages) return;
    languageOptionsContainer.innerHTML = "";

    languages.forEach(language => {
      const label = document.createElement("label");
      label.classList.add("language-option");

      const input = document.createElement("input");
      input.type = "radio";
      input.classList.add("language-selector__radio");
      input.name = "language_code";
      input.value = language.iso;

      if (language.iso === selectedLanguageInput.value) {
        input.checked = true;
        selectedLanguageInput.value = language.iso;
      }

      label.appendChild(input);
      label.appendChild(document.createTextNode(language.name));

      languageOptionsContainer.appendChild(label);
    });
  }

  // Toggle the dropdown visibility
  toggleDropdown(e, target, close = null) {
    if (close && this.dropdownButton.getAttribute("aria-expanded") === "false") return;
    const header = document.querySelector("#header");


    // Ensure settings exist
    this.headerTransparent = JSON.parse(header?.getAttribute("data-settings") || "{}").transparent;
    const isExpanded = this.dropdownButton.getAttribute("aria-expanded") === "true";


    // Toggle dropdown visibility
    this.dropdownButton.setAttribute("aria-expanded", !isExpanded);
    this.dropdownContent.setAttribute("aria-hidden", isExpanded);

    if (isExpanded) {
      this.dropdownContent.style.display = "block";
      this.delegateRoot.off("click", "body", this.handleOutsideClick);
      document.body.classList.remove("scrollLock");
      bodyScrollLock.enableBodyScroll(this.element.querySelector('[data-scrollable]'));
    } else {
      bodyScrollLock.disableBodyScroll(this.element.querySelector('[data-scrollable]'), bodyScrollLockOptions);
      document.body.classList.add("scrollLock");
      this.element.dispatchEvent(
        new CustomEvent("close:search", { bubbles: true })
      );

      this.element.dispatchEvent(
        new CustomEvent("menu:close", { bubbles: true })
      );
      this.delegateRoot.on("click", "body", this.handleOutsideClick);
    }
    this.pageOverlayElement = document.body.querySelector(".localizationOverlay");
    this.pageOverlayElement.classList.toggle("is-visible", !isExpanded);
    this.pageOverlayElement.addEventListener("click", this.toggleDropdownListener);
    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.pageOverlayElement.style.opacity = 0;
    }

    // Restore transparency for larger screens
    if (this.headerTransparent && responsive.matchesBreakpoint("lap_and_up")) {
      header.classList.toggle("Header--Transparent", isExpanded);
    }
  }

  handleCountrySelect(event) {
    let selectedItem = event.target.closest(".RevolutionSelectbox--Item");
    let selectedCountry = selectedItem.getAttribute("data-name");
    let selectedValue = selectedItem.getAttribute("data-value");

    const countryButton = document.querySelector('[data-action="toggle-selectbox"]');
    const countryDropdown = document.querySelector("#country-dropdown");

    countryButton.querySelector("span").textContent = selectedCountry;

    document.querySelector("#country-selector__country-code").value = selectedValue;

    document.querySelectorAll(".RevolutionSelectbox--Item").forEach(el => el.removeAttribute("selected"));
    event.target.setAttribute("selected", "selected");

    countryDropdown.style.display = "none";
    countryButton.setAttribute("aria-expanded", "false");
    countryDropdown.setAttribute("aria-hidden", "true");
  }

}

customElements.define("localization-selectors", LocalizationSelectors);

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll(".Dropdown");
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    let selector;
    switch (this.breakpoint) {
      case "lap-and-up":
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "pocket":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      case "phone":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      case "tablet":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  }

  openDropdown(elem, target) {
    this.lock = true;
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");
    if (!target.classList.contains('faq-button')) {
      this.allDropdowns.forEach((dropdown) => {
        if (
          dropdown !== target.closest(".Dropdown") &&
          dropdown.querySelector("[aria-expanded='true']") &&
          !dropdown.classList.contains("do-not-close")
        ) {
          this.closeDropdown(dropdown);
        }
      });
    }

    DropdownButton.setAttribute("aria-expanded", "true");

    new RevolutionAnimation(DropdownContent, "true").slideDown();

    setTimeout(() => {
      this.lock = false;
    }, 300);
  }

  closeDropdown(elem) {
    this.lock = true;
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);

    setTimeout(() => {
      if (DropdownContent.getAttribute("aria-hidden") == "false") {
        DropdownContent.setAttribute("aria-hidden", "true");
      }

      this.lock = false;
    }, 300);
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";
    const parentElement = mainDropdown.parentElement;
    if (parentElement && parentElement.classList.contains('sideBar--DropdownContainer')) { //Trigger reflow for Chrome overflow bug
      parentElement.style.overflow = 'hidden';
      setTimeout(function () {
        parentElement.style.overflow = 'visible';
      }, 300)
    }



    if (!this.lock) {
      if (isOpen) {
        // If dropdown is open, close it
        this.closeDropdown(mainDropdown, target);
      } else {
        // If dropdown is closed, open it
        this.openDropdown(mainDropdown, target);
      }
    }
  }
}

const allDropdowns = new Dropdown();

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {

    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("reachEnd", () => {
      this.element.classList.add("swiper--end");
    });

    this.swiperElement.on("fromEdge", () => {
      this.element.classList.remove("swiper--end");
    });

    this.swiperElement.on("slideChange", function () {
      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });
  }

  destroy() {
    this.swiperElement.destroy();
  }
}

class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.headerHeight = document.body.querySelector("#header")?.offsetHeight || 0;

    this.headerTransparent = document.body
      .querySelector("#header")
      .classList.contains("Header--Transparent")
      ? true
      : false;

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () { };
    this.onClose = options["onClose"] || function () { };
    this.isOpen = false;

    if (this.element.getAttribute("data-id") == "mobile-menu") {
      this.footerHeight = this.element.querySelector(".Drawer--Footer")?.offsetHeight || 0;
      setTimeout(() => {
        document.documentElement.style.setProperty(
          "--mobile-menu-height",
          `${this.footerHeight}px`
        );
      }, 200);
    }
    this.bindEvents();
  }

  bindEvents() {

    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );

    this._closeListener = this.closeDrawer.bind(this);
    this.delegateBody.on("drawer:close-other", this._closeListener);
  }


  toggleDrawer(event) {
    event.preventDefault();
    this.clearAll = false;
    if (event && event.target.id === 'hamburger-menu-icon') {
      this.element.dispatchEvent(
        new CustomEvent("sidebar-drawer:close", {
          bubbles: true,
        })
      );
      this.clearAll = true;
    }
    if (this.isTranslating) {
      return;
    }
    this.isOpen ? this.closeDrawer(event) : this.openDrawer(event);
  }

  openDrawer() {
    if (this.isOpen) {
      return;
    }

    if (event && event.target.id === 'hamburger-menu-icon' && document.querySelector('.next__drawer__level[aria-hidden="false"]')) return;


    dynamicVars.syncHeight();

    this.isTranslating = true;

    if (this.headerTransparent) {
      document.body
        .querySelector("#header")
        .classList.remove("Header--Transparent");
    }


    this.headerScrolled = document.body
      .querySelector("#header")
      .classList.contains("Header--Scrolled")
      ? true
      : false;

    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );

    this.transitionStartedListener = this.translateTransitionStarted.bind(this);
    this.element.addEventListener("transitionend", this.transitionStartedListener);

    if (this.element.getAttribute("id") == "product-card-popup") {
      this.element.dispatchEvent(
        new CustomEvent("product-card-drawer:open", {
          bubbles: true,
          detail: {
            product: event.target.dataset.productId,
          },
        })
      );
    }


    if (this.element.getAttribute("id") == "Drawer" || this.element.classList.contains('next__drawer__level')) {
      this.element.parentElement.style.display = "block";
      this.hamburger = document.body.querySelector(".header-hamburger");
      this.hamburger.classList.add("is-active");
      this.pageOverlayElement = this.element.parentElement.querySelector('.sectionOverlay');
      if (this.headerTransparent) {
        document.body
          .querySelector("#header")
          .classList.remove("Header--Transparent");
      }

      requestAnimationFrame(() => {
        this.element.parentElement.querySelector('.Drawer--Footer').setAttribute('aria-hidden', 'false');
      });

    }
    this.element.setAttribute("aria-hidden", "false");
    this.element.offsetHeight;

    if ((this.element.id === "collection__sort-drawer" || this.element.id === "collection__filter-drawer") && responsive.matchesBreakpoint("lap_and_up")) {
      this.pageOverlayElement.style.opacity = 0;
    } else {
      this.pageOverlayElement.removeAttribute('style');
    }

    requestAnimationFrame(() => {
      this.element.setAttribute("aria-expanded", "true");
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener("click", this._closeListener);
    });

    if (this.element.getAttribute("data-id") == "cart-drawer") {
      this.headerHeightCart = this.element.querySelector(".Drawer--Header")?.offsetHeight || 0;
      this.footerHeightCart = this.element.querySelector(".Drawer--Footer")?.offsetHeight || 0;
      document.documentElement.style.setProperty(
        "--cart-footer-height",
        `${this.footerHeightCart}px`
      );
      document.documentElement.style.setProperty(
        "--cart-header-height",
        `${this.headerHeightCart}px`
      );
    }

    const focus = this.element.querySelector("[data-scrollable]");
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");
    this.isOpen = true;



    if (this.element.getAttribute("id") == "product-card-popup") {
      this.pageOverlayElement.style.opacity = 0.1;
    }
    this.onOpen();
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }

    this.isTranslating = true;

    document.body.classList.remove("scrollLock");

    this.transitionEndedListener = this.translateTransitionEnded.bind(this);
    this.element.addEventListener("transitionend", this.transitionEndedListener);

    this.element.setAttribute("aria-expanded", "false");
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);

    if (this.element.getAttribute("id") == "product-card-popup") {
      this.pageOverlayElement.style.opacity = 0;
    }

    if (event && event.target.classList.contains('sectionOverlay')) {
      this.clearAll = true;
    }

    if (this.element.id == 'Drawer' || this.element.classList.contains('next__drawer__level')) {
      this.hamburger.classList.remove("is-active");
      this.element.parentElement.querySelector('.Drawer--Footer').setAttribute('aria-hidden', 'true');
    }

    this.onClose();

    this.isOpen = false;

    if ((this.element.id == 'Drawer' || this.element.classList.contains('next__drawer__level')) && (document.querySelector('.next__drawer__level[aria-expanded="true"]') || document.querySelector('.menu__drawer[aria-exapnded="true"]'))) return;
    if (this.headerTransparent && !this.headerScrolled) {
      document.body
        .querySelector("#header")
        .classList.add("Header--Transparent");
    } else if (this.headerScrolled) {
      document.body
        .querySelector("#header")
        .classList.remove("Header--Transparent");
    }
  }

  translateTransitionStarted() {
    if (event.propertyName == "transform" || event.propertyName == 'opacity') {
      this.element.removeEventListener("transitionend", this.transitionStartedListener);
      this.isTranslating = false;
      trapFocus(this.element);
      if (this.element.id === 'accountDrawer') this.element.querySelector("[aria-visible='true'] .input-placeholder")?.focus();
    }
  }

  translateTransitionEnded() {
    if (event.propertyName == "transform" || event.propertyName == 'opacity') {
      this.element.setAttribute('aria-hidden', 'true');

      const focus = this.element.querySelector("[data-scrollable]");
      if (!document.body.classList.contains("scrollLock")) {
        if (this.clearAll) {
          document.querySelector('main-menu-dropdown').style.display = "none";
        }
        bodyScrollLock.clearAllBodyScrollLocks();
      }

      removeTrapFocus(this.element);
      this.isTranslating = false;

      this.element.removeEventListener(
        "transitionend",
        this.transitionEndedListener
      );
    }
  }
}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    let lastScrollTime = 0;

    window.addEventListener("scroll", () => {
      this.lastScrollTime = performance.now();
    }, { passive: true });

    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              let newContentToAnimate = Array.from(node.querySelectorAll("[data-animation]"));
              if (node.getAttribute("data-animation")) {
                newContentToAnimate = [node];
              }

              newContentToAnimate.forEach((item) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    this.element.style.pointerEvents = "none";
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  // A function to animate a list of elements by scaling them out
  elementScaleOut(elements) {
    // Get the animation duration and delay from the theme settings
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;

    // Loop through each element in the list
    elements.forEach((element, index) => {
      // Check if the element has already been loaded
      if (element.hasAttribute("data-loaded")) {
        // If so, skip this element
        return;
      }

      // Mark the element as loaded to prevent duplicate animations
      if (!element.hasAttribute("always-animate")) element.setAttribute("data-loaded", true);


      // Define the animation keyframes
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];

      // Define the animation options
      const animationOptions = {
        duration: animationDuration,
        fill: "forwards",
      };

      // Schedule the animation with a delay based on the element's position in the list
      setTimeout(() => {
        element.animate(keyframes, animationOptions);
      }, animationDelay * index);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
      if (!item.hasAttribute("always-animate")) item.setAttribute("data-loaded", true);
    });
  }

  elementFadeIn(toReveal) {

    toReveal.forEach((item, i) => {
      // Check if element already has an active animation  
      if (item.getAttribute("data-loaded")) {
        return;
      }

      setTimeout(() => {
        var elementMove = [
          { opacity: "0" },
          { opacity: "1" },
        ];

        let animation = item.animate(elementMove, {
          duration: 750,
          easing: "ease",
          fill: "forwards",
        });


      }, window.theme.animationBetweenElements * i);

      if (!item.hasAttribute("always-animate")) {
        item.setAttribute("data-loaded", true);
      }
    });
  }


  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      if (!item.hasAttribute("always-animate")) item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      if (!item.hasAttribute("always-animate")) item.setAttribute("data-loaded", true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        if (!item.hasAttribute("always-animate")) item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        if (!item.hasAttribute("always-animate")) item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      if (!item.hasAttribute("always-animate")) item.setAttribute("data-loaded", true);
    });
  }

  animateElement(animatedItem, index) {
    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const integer = options.integer;
        const elements = [];

        // Iterate over the IntersectionObserverEntry objects in the results array.
        results.forEach((result) => {
          // Check if the target element is intersecting the root element or if its intersection ratio is greater than 0.

          if (result.isIntersecting || result.intersectionRatio > 0) {

            // Add the target element to the elements array.
            const timeSinceScroll = performance.now() - this.lastScrollTime;
            if (result.target.hasAttribute("always-animate") && document.body.classList.contains("scrollLock") || result.target.hasAttribute("always-animate") && timeSinceScroll < 100 || result.target.getAnimations().length > 0) { return; }
            elements.push(result.target);

            // Unobserve the target element.
            if (!result.target.hasAttribute("always-animate")) {

              this.intersectionObserver[integer].unobserve(result.target);
            }

          } else {
            if (result.target.hasAttribute("always-animate")) {

              result.target.getAnimations().forEach(animation => animation.cancel());
            }
          }
        });

        // If there are no elements to reveal, return.
        if (elements.length === 0) {
          return;
        }

        // An object that maps each animation type to the corresponding animation function.
        const animations = {
          elementFromTop: "elementFromTop",
          elementFromBottom: "elementFromBottom",
          elementFromRight: "elementFromRight",
          elementFromLeft: "elementFromLeft",
          elementFromLeftBig: "elementFromLeftBig",
          elementFromRightBig: "elementFromRightBig",
          elementScaleIn: "elementScaleIn",
          elementScaleOut: "elementScaleOut",
          elementFadeIn: "elementFadeIn",
        };

        // Get the animation function corresponding to the type from the animations object.
        const animation = animations[options.type];
        // If the animation function exists, call it with the elements array.
        if (animation) {
          this[animation](elements);
        }
      },
      { threshold: 0.1 }
    );

    if (animatedItem.classList.contains("animatedContent")) {
      this.intersectionObserver[index].observe(animatedItem);
    }

    animatedItem.querySelectorAll(".animatedContent").forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (this.options["noVariants"] == "true") {
      this.toggleAddButton();
    }
  }

  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC");


    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    addButton.removeAttribute("disabled");
    addButton.classList.remove("ProductCard--Sold__Out");
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define("product-form", ProductForm);

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.delegateElement = new Delegate(this);
    this.element = this;
    new AddToCart(this);
    this.price = this.querySelector(".priceItem--regular-hover");
    this.comparePrice = this.querySelector(".compare_change--hover");
    this.originalContainer = this.querySelector(".price-original")
    this.copyContainer = this.querySelector(".price--hover")
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "mouseover",
      "[data-action=change-data]",
      this.changeData.bind(this)
    );

    this.delegateElement.on(
      "mouseleave",
      "[data-action=change-data]",
      this.returnInitPrice.bind(this),
      true
    );
  }

  changeData(event) {
    this.originalContainer.style.display = "none"

    const selectbox = event.target.closest(".Selectbox");
    const formInput = selectbox.querySelector(".inputSelectboxCheckbox");
    const productForm = this.querySelector(".product-card-form");
    this.price.textContent = formInput.dataset.price;
    this.comparePrice.textContent = formInput.dataset.comparePrice;

    if (formInput.dataset.comparePrice != "" && formInput.dataset.available === "false") {
      this.price?.classList.add("price--unavailable")
    } else if (formInput.dataset.comparePrice != "" && formInput.dataset.available === "true") {
      this.price?.classList.add("price--lower-alert");
    } else {
      this.price?.classList.remove("price--lower-alert");
      this.price?.classList.remove("price--unavailable")
    }

    event.target.classList.add("text-underline");

    productForm.dataset.productid = formInput.dataset.variantId;
    const input = productForm.querySelector('input[name="id"]');
    input.value = input.dataset.id = input.dataset.productid = formInput.dataset.variantId;
    this.copyContainer.style.display = "block"
  }

  returnInitPrice() {
    this.originalContainer.style.display = "block"
    this.copyContainer.style.display = "none"
  }

}

customElements.define("product-card", ProductCard);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector(
      ".component-countDownWrapper"
    );

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options["countdownString"];
    counterString = counterString.replace(
      "{countdown}",
      '<span class="u-pb6 component-countDown">00:00:00</span>'
    );
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;

    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector(".component-countDown");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options["countdownType"] == "to_date") {
      countDate = new Date(this.options.countdownDate);
    }

    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;

    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);

    const [targetHours, targetMinutes] = this.options.countdownTime
      .split(":")
      .map(Number);
    if (
      targetHours < currentHours ||
      (targetHours === currentHours &&
        targetMinutes <= currentMinutes &&
        this.options["countdownType"] == "reccuring")
    ) {
      textDays = this.dayDifference - 1;
    } else if (this.options["countdownType"] == "reccuring") {
      textDays = this.dayDifference;
    }

    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);

class cartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.drawer = new Drawer(this.element, {
      onClose: () => {
        this.isOpen = false;
        this.recommendationsOpen = false;
        this.alreadyEntered = false;
      },
      onOpen: () => {
        this.isOpen = true;
        this.alreadyEntered = true;
      },
    });
    this.loader = this.element.querySelector(".spinningLoader");

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.cartIds = false;
    this.isOpen = false;
    this.recommendationsOpen = false;
    this.recommendationLoading = false;
    this.recommendationsLoaded = false;
    this.alreadyEntered = false;
    new AddToCart(this.element);
    this.bindEvents();
  }

  bindEvents() {
    if (window.theme.listener == "false") {
      if (this.options["showRecommendations"] & !this.alreadyEntered) {
        this.loadRecommendations();
      }
      this.onProductAddedListener = this.onProductAdded.bind(this);
      this.onSidecartOpen = this.onSidecartOpen.bind(this);

      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on("click", '[data-action="update-item-quantity"], [data-action="remove-item"]', this.updateItemQuantity.bind(this));
      this.delegateElement.on("change", '[data-action="update-change-quantity"]', this.updateItemQuantity.bind(this));
      this.delegateElement.on("quantity:changed", ".cart-item__quantity", this.updateItemQuantity.bind(this));

      window.theme.listener = "true";
    }
  }

  handleTransitionEnd(target) {
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    this.recommendationContainer.removeEventListener(
      "transitionend",
      this.transitionEndHandler
    );
  }

  onSidecartOpen() {
    this.isOpen = true;
    if (this.options["showRecommendations"] & !this.alreadyEntered) {
      this.loadRecommendations();
    }
    this.alreadyEntered = true
  }

  async updateItemQuantity(event, target) {
    event.preventDefault();
    const cartItem = target.closest(".cart-item");
    const itemLoader = cartItem.querySelector(".itemLoader");
    itemLoader.classList.add("is-visible");

    let quantity;
    if (target.tagName === "INPUT") {
      quantity = Math.max(parseInt(target.value, 10) || 0, 0);
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"), 10);
    }

    const payload = {
      id: target.getAttribute("data-line-id"),
      quantity: quantity,
    };

    if (quantity === 0) {
      cartItem.classList.add("removing");
      const id = cartItem.dataset.id;
      if (this.cartIds) {
        this.cartIds = this.cartIds.filter((item) => item !== id);
      }
      const nextItem = cartItem.nextElementSibling;
      const height = cartItem.offsetHeight;
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );
      setTimeout(() => {
        cartItem.remove();
        if (!nextItem) {
          return;
        }
        nextItem.classList.add("repo--top");
        setTimeout(() => {
          nextItem.classList.remove("repo--top");
        }, 350);
      }, 350);
    }

    try {
      const response = await fetch(
        `${window.routes.localeRootUrl}/cart/change.js`,
        {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      if (data.item_count == 0) {
        this.loader.classList.add("is-visible");
        this.renderCart(false, false);
      }
      if (quantity == 0 && data.item_count > 0) {
        if (this.options.showRecommendations) {
          this.options["productId"] = data.items[data.items.length - 1].product_id;
          this.renderCart(false, false, false, null);
          return;
        }
      }
      if (data.item_count > 0 && quantity > 0) {
        this.renderCart(target.getAttribute("data-id"), true);
      }
    } catch (error) {
      console.error("Failed to update item quantity:", error);
      // Optionally, show an error message to the user
    }
  }

  onProductAdded() {
    let details = false;
    if (event.detail) {
      details = event.detail;
    }



    if (window.theme.cartCount == 0 && this.isOpen == true) {
      this.loader.classList.add("is-visible");
    }


    this.renderCart(false, false, true, details).then(() => {
      if (this.element.hasAttribute("data-open-drawer")) {
        if (!this.isOpen) {
          this.isOpen = true;
          if (this.options["showRecommendations"]) {
            this.loadRecommendations();
          }
          this.alreadyEntered = true;
          this.drawer.openDrawer();
        }
      }
    });
  }

  renderCart(
    lineNumber,
    quantityChange,
    productAdd,
    productAddEvent,
    updateCount
  ) {
    this.pageLoader.style.width = 100 + "%";
    var _this = this;
    return fetch(
      window.routes.localeRootUrl + "/?section_id=main-cart_drawer",
      {
        credentials: "same-origin",
        method: "GET",
      }
    ).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(
          html,
          lineNumber,
          quantityChange,
          productAdd,
          productAddEvent,
          updateCount
        );
      });
    });
  }

  recheckHeights() {

    const headerHeightCart = this.element.querySelector(".Drawer--Header")?.offsetHeight || 0;
    const footerHeightCart = this.element.querySelector(".Drawer--Footer")?.offsetHeight || 0;
    document.documentElement.style.setProperty(
      "--cart-footer-height",
      `${footerHeightCart}px`
    );
    document.documentElement.style.setProperty(
      "--cart-header-height",
      `${headerHeightCart}px`
    );

  }

  replaceContent(
    html,
    lineNumber,
    quantityChange,
    productAdd,
    productAddEvent,
    updateCount
  ) {
    if (!updateCount) {
      // Prepare the page loader animation
      this.pageLoader.style.left = "unset";
      this.pageLoader.style.right = "0px";
      this.pageLoader.style.width = "0%";

      setTimeout(() => {
        this.pageLoader.style.left = "0px";
        this.pageLoader.style.right = "unset";
      }, 550);
    }

    // Create a temporary element to parse the new HTML content
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    // Extract options and update cart count
    const newOptions = JSON.parse(
      tempElement.querySelector("#cart-drawer").getAttribute("data-settings")
    );

    const oldItemCount = this.options.itemCount || 0;
    this.options = newOptions;

    const itemCount = newOptions.itemCount;
    window.theme.cartCount = parseInt(itemCount);
    this.cartCount = document.querySelector(".cart__count");
    this.cartCount.textContent = itemCount;


    if (updateCount) { this.updateCartFooter(tempElement); return; }
    if (lineNumber) {
      this.updateCartItem(lineNumber, tempElement);
    } else if (productAdd && oldItemCount > 1) {
      this.addContent(tempElement, productAddEvent);
    } else {
      this.replaceCartContent(tempElement);
    }

    this.updateCartFooter(tempElement);
    this.updateShippingBar(tempElement);
    this.recheckHeights();
    // Additional actions after a brief delay
    setTimeout(() => {
      if (
        this.options.showRecommendations &&
        !quantityChange &&
        this.isOpen == true
      ) {
        this.loadRecommendations();
      }
    }, 200);
  }

  updateCartItem(lineNumber, tempElement) {
    const cartItemParent = this.element.querySelector(`#${lineNumber}`);
    const newCartItemInfo = tempElement.querySelector(
      `#${lineNumber} .cart-item__info`
    );

    if (!cartItemParent) {
      this.element.querySelector(".itemLoader").classList.remove("is-visible");
    } else {
      cartItemParent
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    }

    if (newCartItemInfo) {
      cartItemParent.replaceChild(
        newCartItemInfo,
        cartItemParent.querySelector(".cart-item__info")
      );
    } else if (cartItemParent) {
      this.removeCartItem(cartItemParent);
    }
  }

  addContent(tempElement, productAddEvent) {
    if (this.isOpen) {
      this.element.querySelector(".cart-drawer__content").scrollTop = 0;
    }
    const itemToAdd = tempElement.querySelector(
      `#cart-item__${productAddEvent.variant}`
    );
    const cartWrapper = this.element.querySelector(".cart-drawer__items");
    const firstItem = cartWrapper.firstElementChild;
    if (cartWrapper.querySelector(`#cart-item__${productAddEvent.variant}`)) {
      this.updateCartItem(`cart-item__${productAddEvent.variant}`, tempElement);
    } else {
      const height = this.calculateDetachedElement(itemToAdd);
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );
      firstItem.classList.add("repo--bottom");
      this.loader.classList.remove("is-visible");
      setTimeout(() => {
        cartWrapper.prepend(itemToAdd);
        itemToAdd.classList.add("repo--adding");
        firstItem.classList.remove("repo--bottom");

        setTimeout(() => {
          itemToAdd.classList.remove("repo--adding");
        }, 350);
      }, 350);
    }
  }

  calculateDetachedElement(element) {
    // 1. Create a detached container
    const detachedContainer = document.createElement("div");
    detachedContainer.style.position = "absolute";
    detachedContainer.style.visibility = "hidden";
    detachedContainer.style.height = "auto";
    detachedContainer.style.width = "100%";
    detachedContainer.style.top = "-9999px"; // Off-screen positioning

    // 2. Append the new item to the detached container
    detachedContainer.appendChild(element);

    // 3. Append the detached container to the body (but off-screen)
    this.element.appendChild(detachedContainer);

    // 4. Get the offset height of the new item
    const newItemHeight = element.offsetHeight + 4;

    // 5. Remove the detached container from the DOM
    this.element.removeChild(detachedContainer);

    // Now you have the height of the new item without it ever being visible
    return newItemHeight;
  }

  updateShippingBar(tempElement) {
    const newShippingBar = tempElement.querySelector(
      ".cart-drawer__shipping-progress-bar"
    );
    if (newShippingBar) {
      const currentShippingBar = this.element.querySelector(
        ".cart-drawer__shipping-progress-bar"
      );
      if (currentShippingBar) {
        let percent = newShippingBar.dataset.percent;
        if (percent > 100) {
          percent = 100;
        }
        currentShippingBar.dataset.percent = percent;
        currentShippingBar.style.width = `${percent}%`;
        if (percent == 100) {
          currentShippingBar.classList.add("done");
          currentShippingBar.classList.remove("active");
        } else {
          currentShippingBar.classList.remove("done");
          currentShippingBar.classList.add("active");
        }
        this.element.querySelector(".cart-drawer__shipping-text").innerHTML =
          tempElement.querySelector(".cart-drawer__shipping-text").innerHTML;
      } else {
        const container = this.element.querySelector(
          ".cart-cart-drawer__form-container"
        );
        container.insertBefore(
          tempElement.querySelector(".cart-drawer__shipping"), container.firstChild
        );
      }
    }
  }

  updateCartFooter(tempElement) {
    const itemCount = this.options.itemCount;
    const cartFooter = this.element.querySelector(".cart-drawer__footer");
    if (tempElement.querySelector(".cart-drawer__footer") && !cartFooter) {
      this.element.querySelector('.cart-drawer__wrapper').appendChild(tempElement.querySelector(".cart-drawer__footer"));
    } else if (tempElement.querySelector(".cart-drawer__footer") && cartFooter) {
      this.element.querySelector('.cart-drawer__wrapper').replaceChild(tempElement.querySelector(".cart-drawer__footer"), cartFooter);
    }
    if (itemCount > 0) {

      const footerParent = this.element.querySelector(".cart-drawer__wrapper");
      const newFooterTotals = tempElement.querySelector(
        ".cart-drawer__footer"
      );
      if (!footerParent || !newFooterTotals) return;
      footerParent.replaceChild(
        newFooterTotals,
        footerParent.querySelector(".cart-drawer__footer")
      );



    } else {
      this.clearCartFooter(tempElement);
    }
  }

  clearCartFooter(tempElement) {
    if (!tempElement.querySelector(".cart-drawer__wrapper")) return;
    const cartFooter = this.element.querySelector(".cart-drawer__footer");
    if (cartFooter) {
      cartFooter.classList.add("removing");
      cartFooter.addEventListener("transitionend", () => {
        cartFooter.remove();
      }, { once: true });
    }
  }

  replaceCartContent(tempElement) {
    const cartWrapperParent = this.element.querySelector(
      ".cart-drawer__content"
    ).parentNode;
    const currentScrollPosition = this.element.querySelector(
      ".cart-drawer__content"
    ).scrollTop;

    cartWrapperParent.replaceChild(
      tempElement.querySelector(".cart-drawer__content"),
      this.element.querySelector(".cart-drawer__content")
    );
    setTimeout(() => {
      this.loader.classList.remove("is-visible");
    }, 200);
    this.element.querySelector(".cart-drawer__content").scrollTop =
      currentScrollPosition;


  }

  loadRecommendations(related) {
    let recommendationsContainer = this.element.querySelector(".cart-drawer__recommendations");
    if (this.recommendationLoading == true) return;
    this.recommendationLoading = true;

    const productId = this.options["productId"];

    const baseUrl = window.routes.localeRootUrl;
    let url;

    // Determine the URL based on whether a product ID is present
    if (!productId) {
      url = "?section_id=helper-recommendations";
    } else {
      let limit = this.element.getAttribute("product-limit");
      url = `${baseUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&limit=${limit}&intent=complementary`;
      if (related) {
        url = url.replace('complementary', 'related');
      }
    }

    recommendationsContainer.classList.remove("transition--done");
    if (this.recommendationsOpen == true) {
      recommendationsContainer.classList.add("transition");
    }

    return fetch(url)
      .then((response) => response.text())
      .then((content) => {
        this.recommendationLoading = false;
        const container = document.createElement("div");
        container.innerHTML = content;


        let recommendationsHTML = container.querySelector(".cart-drawer__upsell")?.innerHTML;
        recommendationsContainer = this.element.querySelector(".cart-drawer__recommendations");
        const newFirstItem = container.querySelector(".cart-drawer__rec-item")?.dataset.id;
        const existingFirstItem = this.element.querySelector(".cart-drawer__rec-item")?.dataset.id;


        if (newFirstItem == existingFirstItem) { return; }

        if (recommendationsHTML) {
          recommendationsContainer.innerHTML = recommendationsHTML;
          this.initializeSwiper();
          new AddToCart(this.element);
          recommendationsContainer.setAttribute(
            "data-animation",
            "elementFromRight"
          );
          if (window.theme.enableAnimations) {
            new RevolutionAnimation(recommendationsContainer);
          }

        }
      })
      .catch((error) => {
        console.error("Failed to load recommendations:", error);
      });
  }

  handleTransitionRec(target, container) {
    if (event.propertyName !== "transform") return;
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    container.classList.remove("transition");
    this.recommendationsOpen = false;
    this.el.removeEventListener("transitionend", this.transitionRecEnd);
  }

  initializeSwiper() {
    new Swiper(".helper-recomm-swiper", {
      slidesPerView: 1.1501,
      spaceBetween: 8,
      slidesOffsetBefore: 8,
      slidesOffsetAfter: 8,
      rewind: false,
      navigation: {
        nextEl: ".cart-recommendations__swiper-button--next",
        prevEl: ".cart-recommendations__swiper-button--prev",
      },
      nested: true,
      pagination: {
        el: ".cart-recommendations__pagination",
        bulletClass: "swiper-pagination__pagination-bullet",
        bulletActiveClass: "swiper-pagination__pagination-bullet--active",
        type: "bullets",
        clickable: true
      },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        1025: {
          slidesPerView: 1.4965,
          spaceBetween: 8,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16
        },
      },
    });
  }
}
customElements.define("cart-drawer", cartDrawer);

class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".featured-collection__swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

    this.bindEvents();
  }

  bindEvents() {
    this.isPageLoaded =
      document.readyState === "complete" ||
      document.readyState === "loaded" ||
      document.readyState === "interactive";
    if (!this.isPageLoaded) {
      window.addEventListener("load", this.onPageLoaded.bind(this));
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (!this.carousel) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "-100px 0px 200px 0px",
    }).observe(this);
  }
}
customElements.define("featured-collection", FeaturedCollectionSection);

class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.delegateElement = new Delegate(this.element);
    if (this.options["numberOfSlides"] > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.onImagesReady = this.createObserver.bind(this);
      this.element.addEventListener("swiper:slide-changed", this.onImagesReady);
      this.createObserver();
    } else {
      this.createObserver();
    }
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    const target = this.element;
    this.observer.observe(target);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }
  changeImageQuality(singleItem) {
    // Get the current breakpoint.
    const breakpoint = responsive.getCurrentBreakpoint();

    let imageContainers;
    // Determine which element(s) to search for based on the singleItem parameter.
    if (singleItem) {
      imageContainers = Array.from(
        this.element.querySelectorAll(".Banner__ImageContainer--Swap")
      );
    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];
      imageContainers = Array.from(
        cellElement.querySelectorAll(".Banner__ImageContainer--Swap")
      );
    }

    // If no image containers are found, return.
    if (imageContainers.length === 0) {
      return;
    }

    // Determine which image to reveal based on the current breakpoint.
    let imageToReveal;
    if (
      breakpoint === "pocket" ||
      breakpoint === "phone" ||
      breakpoint === "tablet"
    ) {
      imageToReveal = imageContainers[0].querySelector(".Banner__Image");
    } else {
      if (imageContainers.length == 2) {
        imageToReveal = imageContainers[1].querySelector(
          "not_mobile.Banner__Image"
        );
      } else {
        imageToReveal = imageContainers[0].querySelector(
          "not_mobile.Banner__Image"
        );
      }
    }

    // If the image to reveal is not found or has already been loaded, return.
    if (!imageToReveal || imageToReveal.dataset.loadedImage === "true") {
      return;
    }

    if (imageToReveal.dataset.src) {
      // Replace the image URL with a higher quality version.
      const replaceUrl = imageToReveal.dataset.src.replace(
        "{width}x",
        "width=2600"
      );
      imageToReveal.src = replaceUrl;
      imageToReveal.dataset.loadedImage = "true";
    }
  }
}
customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.scrollableElement = this.element.querySelector("[data-scrollable]");
    this.headerTransparent = false;
    this.lastScrollPosition = 0;


    this.bindEvents();

    if (this.options.sticky) {
      this.toggleSticky();
    }

    document.documentElement.style.setProperty(
      "--header-height-fixed",
      document.querySelector("#header").offsetHeight + "px"
    );

    this.updateVisibleHeight();

    this.initializeScrollBehavior();
  }

  bindEvents() {
    if (this.options.transparent && this.options.sticky) {
      this.toggleColorListener = this.toggleColor.bind(this);
      window.addEventListener("scroll", this.toggleColorListener);
    }

    this.closeMenuListener = this.closeMenu.bind(this);
    this.openMenuListener = this.openMenu.bind(this);
    this.openSubmenu = this.handleSubmenu.bind(this);
    this.hideSubmenu = this.hideSubmenus.bind(this);
    this.isOpen = false

    if (!this.options.sticky) {
      window.addEventListener("scroll", this.toggleColorListener);
    }


    this.delegateElement.on(
      "mouseenter",
      ".open-submenu",
      this.openSubmenu,
      true
    );

    this.delegateElement.on(
      "mouseenter",
      ".desktop_menu_links_list",
      this.openSubmenu,
      true
    );

    this.delegateElement.on(
      "mouseenter",
      "[aria-hasMenu='true']",
      this.openMenuListener,
      true
    );

    this.delegateElement.on('mouseleave', '.header__wrapper', this.closeMenuListener, true);

    this.delegateElement.on(
      "click",
      ".header-link_list",
      this.closeMenuListener,
      true
    );
    this.delegateElement.on(
      "focusin",
      "[aria-hasMenu='true']",
      this.openMenuListener,
      true
    );

    this.delegateElement.on(
      'mouseover',
      ["aria-singlemenu", ".mainLinks"],
      this.closeMenuListener,
      true
    )

    this.delegateElement.on(
      "focusin",
      "[aria-singleMenu], .mainLinks",
      this.closeMenuListener,
      true
    );

    this.delegateBody.on("menu:close", this.closeMenuListener);
    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));


  }





  initializeScrollBehavior() {
    const elements = [
      this.element.querySelector(".header__desktop-anchor"),
      this.element.querySelector(".header__mobile-anchor"),
    ];

    const toggleClasses = (isActive) => {
      elements.forEach((el) => {
        if (el) {
          el.classList.toggle("active", isActive);
          el.classList.toggle("inactive", !isActive);
        }
      });
    };

    const handleScroll = () => {
      const currentScroll = window.scrollY;

      toggleClasses(currentScroll > 0); // Toggle active/inactive classes for elements

      this.prevOffset = currentScroll;
    };

    window.addEventListener("scroll", handleScroll);

    this.prevOffset = 0;
    handleScroll();
  }




  updateVisibleHeight() {
    setTimeout(() => {
      const rect = this.element.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // Calculate the visible height
      let visibleHeight =
        Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

      // Ensure the visibleHeight is never negative
      visibleHeight = Math.max(visibleHeight, 0);
      // Update the height of header with the visible height
      document.documentElement.style.setProperty(
        "--header-dynamic-height",
        `${visibleHeight}px`
      );

      document.documentElement.style.setProperty(
        "--header-height-fixed",
        document.querySelector("#header").offsetHeight + "px"
      );
    }, 250);
  }

  toggleSticky() {
    document.querySelector('.main-header').classList.add("header--Sticky");
  }

  updateMenuPosition() {
    document.documentElement.style.setProperty(
      "--submenu-position",

      `${document.querySelector("#header").offsetHeight}px`
    );
  }


  openMenu(event, target) {
    // Dispatch a custom event to indicate that the menu is being opened

    this.element.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));

    const dropdowns = target.querySelector(".drawer-wrapper-desktop");
    const firstItem = this.element.querySelector(".header-links");
    const firstItemBound = firstItem?.getBoundingClientRect();
    const firstItemWidth = firstItemBound.width;
    const firstItemLeft = firstItemBound.left;

    const targetItem = target.getBoundingClientRect();
    const right = window.innerWidth - firstItemLeft - firstItemWidth;

    const targetToFirstItem = targetItem.left - firstItemLeft;

    const firstMenuItem = target.querySelector('.main-menu__first-column');
    const secondMenuItem = target.querySelector('.main-menu__second-column');
    if (target != firstItem) {


      if (firstMenuItem) {
        firstMenuItem.style.marginLeft = `${109 - firstItemWidth}px`;
        secondMenuItem.style.marginLeft = `${targetToFirstItem - firstItemWidth - 16}px`;
      } else {
        secondMenuItem.style.marginLeft = `${targetToFirstItem + 109}px`;
      }

    }


    let leftMargin = 109;

    if (target == firstItem) {
      leftMargin = firstMenuItem.getBoundingClientRect().width + 16;
    }

    dropdowns.style.width = `${right + leftMargin + 40}px`;
    dropdowns.style.marginLeft = `-${targetToFirstItem + leftMargin}px`;



    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );

    // If the event is a mouseenter event and the target is not the same as the event target, return.
    if (event.type === "mouseenter" && target !== event.target) {
      return;
    }


    if (this.element.classList.contains("Header--Transparent")) {
      this.element.classList.remove("Header--Transparent");
      this.headerTransparent = true;
    }

    target.setAttribute("aria-expanded", "true");

    this.listener = target.parentElement.querySelector(
      ".desktop-menu_dropdown"
    );

    this.pointerTarget = target.closest(".header-links");
    this.listener.addEventListener(
      "animationstart",
      this.animationStartListener
    );
    this.listener.addEventListener("animationend", this.animationStartListener);
    // Update the position of the menu and change the ARIA expanded attribute.
    this.updateMenuPosition(target);
    // Close any siblings of the target element.
    const siblings = Array.from(target.parentElement.children).filter(
      (child) =>
        child !== target && child.getAttribute("aria-expanded") === "true"
    );
    siblings.forEach((item) => item.setAttribute("aria-expanded", "false"));

    // Disable body scroll on the scrollable element inside the menu.
    bodyScrollLock.disableBodyScroll(
      this.scrollableElement,
      bodyScrollLockOptions
    );
  }

  hideSubmenus() {
    const allSubmenus = document.querySelectorAll('.main-menu_multiple_content')
    allSubmenus.forEach(submenu => {
      submenu.setAttribute("aria-expanded", "false");
    });
  }


  handleSubmenu(event, target) {
    this.hideSubmenus();
    const boundingTarget = target.getBoundingClientRect();

    const targetTop = boundingTarget.top;

    document.documentElement.style.setProperty(
      "--submenu-offset",
      `${targetTop}px`
    );

    let menuLinkTitleWrapper = document.querySelectorAll('.menu_link_title_wrapper');
    let submenu = target.querySelector('.main-menu_multiple_content');

    let maxWidth = 0; // Initialize the maximum width to 0

    menuLinkTitleWrapper.forEach(function (link) {
      let linkWidth = link.getBoundingClientRect().width;
      if (linkWidth > maxWidth) {
        maxWidth = linkWidth;
      }
    });

    if (submenu) {
      submenu.setAttribute("aria-expanded", "true");
    }


  }

  closeMenu(event, target) {

    if (event.type === 'mouseleave' && !event.target.classList.contains('header__wrapper')) return;
    if (event.type != "mouseleave" && target && target.closest('.header-links')?.getAttribute('aria-expanded') === 'true') { return; }

    if (event.type === "mouseleave" && !this.element.contains(event.toElement) && !this.element.contains(event.target)) {
      return;
    }
    this.hideSubmenus();

    const openElement = this.element.querySelector('[aria-expanded="true"]');
    if (!openElement) return;
    this.listener = openElement.querySelector(".desktop-menu_dropdown");
    if (!this.listener) return;
    this.pointerTarget = openElement;
    this.listener.addEventListener(
      "animationstart",
      this.animationStartListener
    );
    this.listener.addEventListener("animationend", this.animationStartListener);

    openElement.setAttribute("aria-expanded", "false");

    if (this.options.transparent) {
      this.toggleColor();
    }

    bodyScrollLock.enableBodyScroll(this.scrollableElement);


  }


  toggleColor() {
    const annBar = document.querySelector('.shopify-section-section-announcement_bar');
    // Get the current scroll position
    const currentScroll = window.pageYOffset;

    // Check if we scrolled up (current scroll position is less than the last) 
    if (currentScroll < this.lastScrollPosition && annBar) {

      this.element.closest('.main-header').classList.remove('announcement-bar--move');
      // You can add any custom behavior for scrolling up here
    } else if (annBar && currentScroll > 0) {
      this.element.closest('.main-header').classList.add('announcement-bar--move');
    }

    // Update the classes based on the threshold
    if (currentScroll > 25) {

      this.element.classList.add("Header--Scrolled");
      this.element.classList.remove("Header--Transparent");
    } else {

      this.element.classList.remove("Header--Scrolled");
      this.element.classList.add("Header--Transparent");
    }

    if (this.options.transparent && this.headerTransparent && currentScroll <= 25) {
      this.element.classList.add("Header--Transparent");
    }

    // Save the current scroll position for next time
    this.lastScrollPosition = currentScroll;
  }
  Explanation
}
customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.isOpen = false;
    this.drawers = {}; // Store Drawer instances mapped by their ID
    const allDrawers = this.element.querySelectorAll(".Drawer--wrapper");
    allDrawers.forEach((item) => {
      if (item.id) { // Ensure the element has an ID
        this.drawers[item.id] = new Drawer(item);
      }
    });

    this.previousDrawer = this.drawers['Drawer'];

    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-subdrawer"]',
      this.toggleNextElement.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="toggle-prev-subdrawer"]',
      this.togglePreviusElement.bind(this)
    );

    this.delegateBody.on(
      "sidebar-drawer:close",
      this.toggleElement.bind(this),
      true
    );
  }

  toggleElement(event, target) {
    this.drawers['Drawer'].closeDrawer();
    this.subdrawer = target.querySelectorAll(".next__drawer__level");
    this.subdrawer.forEach(d => this.drawers[d.id].closeDrawer());
    document.body.classList.remove("scrollLock");
    bodyScrollLock.clearAllBodyScrollLocks();
  }

  toggleNextElement(event, target) {
    event.preventDefault();
    let nextEl = target.getAttribute("data-toggle-id");
    const previousDrawerElement = this.element.querySelector(".next__drawer__level[aria-expanded='true']") || this.element.querySelector(".menu__drawer[aria-expanded='true']");
    if (previousDrawerElement) this.previousDrawer = this.drawers[previousDrawerElement.id];
    else this.previousDrawer = this.drawers['Drawer'];
    this.drawers[nextEl].openDrawer();
  }

  togglePreviusElement(event, target) {
    event.preventDefault();
    this.subdrawer = target.closest(".next__drawer__level");
    this.drawers[this.subdrawer.id].closeDrawer();
    if (this.subdrawer.classList.contains('second-lvl')) {
      this.previousDrawer = this.drawers['Drawer'];
    }
    this.previousDrawer?.openDrawer();
  }

}

customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {
      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

 onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.classList.add('load_finished');
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;

    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const isMobile = responsive.matchesBreakpoint("pocket");

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );

        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }
    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
          ? "video/vimeo"
          : "video/mp4";

    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: false,
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }

      _this.bindCustomControls();
    });

    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", function () {
        _this.videoPlayer.muted("true");
      });
    }

    if (this.options["controls"]) {
      let lastTouchTime = 0;

      if (host == "html5") {
        this.videoPlayer.on("touchstart", function (e) {
          lastTouchTime = new Date().getTime();


          if (_this.videoPlayer.paused()) {
            _this.videoPlayer.play();
          } else {
            _this.videoPlayer.pause();
          }
        });
      }
      this.videoPlayer.on("click", function () {


        if (new Date().getTime() - lastTouchTime < 300) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  bindCustomControls() {
    this.stateElement = this.element.querySelector(
      "[data-action='toggle-state']"
    );
    this.soundElement = this.element.querySelector(
      "[data-action='toggle-sound']"
    );

    if (!this.stateElement || !this.soundElement) return;

    this.delegateElement.on("click", "[data-action='toggle-state']", () =>
      this.videoPlayer.paused()
        ? this.videoPlayer.play()
        : this.videoPlayer.pause()
    );
    this.delegateElement.on("click", "[data-action='toggle-sound']", () =>
      this.videoPlayer.muted()
        ? this.videoPlayer.muted(false)
        : this.videoPlayer.muted(true)
    );

    this.videoPlayer.on("play", () =>
      this.stateElement.setAttribute("aria-label", "playing")
    );
    this.videoPlayer.on("pause", () =>
      this.stateElement.setAttribute("aria-label", "paused")
    );
    this.videoPlayer.on("volumechange", () =>
      this.soundElement.setAttribute(
        "aria-label",
        this.videoPlayer.muted() ? "muted" : "unmuted"
      )
    );
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    document.documentElement.style.setProperty(
      "--footer-dynamic-height",
      this.element.offsetHeight + "px"
    );
    window.addEventListener("load", () => {
      document.documentElement.style.setProperty(
        "--footer-dynamic-height",
        this.element.offsetHeight + "px"
      );
      document.documentElement.style.setProperty(
        '--footer-height',
        document.querySelector('footer-component').offsetHeight + 'px'
      );
    });
    responsive.addResizeListener(this, () => {
      document.documentElement.style.setProperty(
        "--footer-dynamic-height",
        this.element.offsetHeight + "px"
      );
    });
  }
}
customElements.define("footer-component", FooterComponent);

var contentCache = {};
let currentPath = location.pathname + location.search;
class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.carouselElementThumbs = this.element.querySelector(".ProductSlider--Thumbnails");
    this.carouselElementThumbsContainer = this.element.querySelector(".product_slider-thumbnails");
    this.bundleContainer = this.element.querySelector("#simple-bundles-io-options");
    if (this.bundleContainer) {
      this.bundleLabel = this.bundleContainer.querySelectorAll("label");
      this.bundleLabel.forEach(label => label.classList.add("u-p3"));
      this.bundleSelect = this.bundleContainer.querySelectorAll("select");
      this.bundleSelect.forEach(select => select.classList.add("u-p3", "custom-select-product"));
    }

    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    this.complementaryEl = this.element.querySelector(
      ".complementary_products--wrapper"
    );

    if (this.complementaryEl) {
      this.handleComplementaryProducts();
    }

    this.changeImageQuality();
    this.valuesWrap = this.element.querySelectorAll(
      ".ProductOption--ValusWrapper"
    );

    new AddToCart(this.element);

    if (this.options["slides_number"] > 1) {
      if (this.options["show_thumbnails"]) {
        if (!new Responsive().matchesBreakpoint("lap_and_up")) {
          this.carousel = new RevolutionSwiper(
            this.carouselElement,
            this.carouselElementThumbs
          );
        }
      } else {
        if (!new Responsive().matchesBreakpoint("lap_and_up")) {
          this.carousel = new RevolutionSwiper(this.carouselElement);
        }
      }
    } else {
      this.carouselElementThumbsContainer.style.display = "none";
    }

    if (this.options["enable_zoom"]) {
      new RevolutionImageZoom(this.carouselElement, this.carousel);
    }

    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");

    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    this.stickyAtcWrapper = this.element.querySelector(
      ".product-module__sticky-atc"
    );

    this.mainAtc = this.element.querySelector(".ProductActions");
    this.footer = document.querySelector(".shopify-section-group-footer-group");



    //add product to the local storage
    this.handleLocalStorage();

    this.bindEvents();
  }


  bindEvents() {
    this.domDelegate.on("price:change", this.updatePrice.bind(this));

    window.addEventListener("scroll", this.showStickyAtc.bind(this));
    this.delegateBody.on("product:added", this.hideStickyTimeout.bind(this));
    this.delegateBody.on("product:error", this.hideStickyTimeout.bind(this));
    window.addEventListener(
      "DOMContentLoaded",
      this.showStickyAtc.bind(this)
    );

    window.addEventListener("popstate", this.reloadPage.bind(this));
    window.addEventListener("DOMContentLoaded", this.reloadWithoutRefresh.bind(this));
    this.domDelegate.on("click", '[data-action="handle-reload"]', this.updateContentWithoutReload.bind(this));
  }

  handleLocalStorage() {
    const maxProducts = 6;
    const productId = this.options["product_id"];

    let viewedProducts = JSON.parse(localStorage.getItem('viewedProducts') || '[]');

    viewedProducts = viewedProducts.filter(p => p !== productId);
    // Add the new product at the beginning
    viewedProducts.unshift(productId);
    // Keep only the last 6 products
    if (viewedProducts.length > maxProducts) {
      viewedProducts = viewedProducts.slice(0, maxProducts);
    }
    localStorage.setItem('viewedProducts', JSON.stringify(viewedProducts));
  }

  async reloadWithoutRefresh() {
    let pdpUrls = this.element.querySelectorAll(
      ".product-module__reload .product-module__selectbox-reload"
    );
    let urlsToFetch = Array.from(pdpUrls).map((link) => link.href);

    const fetchAndCacheContent = async (url) => {
      try {
        const response = await fetch(url);

        if (response.ok) {
          const htmlContent = await response.text();
          contentCache[url] = new DOMParser()
            .parseFromString(htmlContent, "text/html")
            .querySelector(".section__product-module");
        } else {
          console.error("Error fetching data. HTTP status:", response.status);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    await Promise.all(urlsToFetch.map(fetchAndCacheContent));
  }

  updateContentWithoutReload(e) {
    e.preventDefault();
    const url = e.target.href;

    const htmlContent = contentCache[url];
    if (htmlContent) {


      document.title = htmlContent.querySelector('product-component').dataset.title;
      document.body.querySelector(`.section__product-module`).innerHTML =
        htmlContent.innerHTML;

      window.scrollTo(0, 0);

      document.body.dispatchEvent(
        new CustomEvent("recommendations:reload", {
          bubbles: true,
          detail: htmlContent.querySelector('.product-module').dataset.productId
        })
      );

      Shopify.PaymentButton.init();
      // Optionally, update the URL in the address bar without a full page reload
      history.pushState(null, null, url);
      currentPath = location.pathname + location.search;
    } else {
      window.location.href = url;
    }
  }

  reloadPage(e) {
    const n = location.pathname + location.search; n !== currentPath && (currentPath = n, window.location.reload())
  }

  updatePrice(event) {
    const priceToBeChanged = this.element.querySelectorAll(".mainProductPrice");
    const comaprePriceToBeChanged = this.element.querySelectorAll(
      ".variant_compare_at_price"
    );


    let quantity = 1;

    if (event.detail.eventName === "variant") {
      const newSinglePrice = parseInt(event.detail.price_raw);
      const newFinalPrice = newSinglePrice;
      const priceFormatted = Shopify.formatMoney(
        quantity * newFinalPrice,
        window.theme.moneyFormat
      );
      priceToBeChanged.forEach((price) => {
        price.innerHTML = priceFormatted;
      });

      const newCompareAtPrice = parseInt(event.detail.compare_at_price);
      const newFinalCompareAtPrice = newCompareAtPrice;
      const priceFormattedCompare = Shopify.formatMoney(
        quantity * newFinalCompareAtPrice,
        window.theme.moneyFormat
      );

      comaprePriceToBeChanged.forEach((price) => {
        newFinalCompareAtPrice === 0 || !newFinalCompareAtPrice ? price.style.display = "none" : price.style.display = "";
        price.innerHTML = priceFormattedCompare;
      });
    } else {
      return;
    }
  }

  hideStickyTimeout() {
    this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
  }

  showStickyAtc() {
    let footerTop = 9999;
    if (this.footer) {
      footerTop = this.footer.getBoundingClientRect().top + window.scrollY;
    }
    if (responsive.matchesBreakpoint('pocket')) {
      if (
        window.scrollY + window.innerHeight <
        footerTop
      ) {
        this.stickyAtcWrapper.setAttribute("aria-hidden", false);
      } else {
        this.stickyAtcWrapper.setAttribute("aria-hidden", true);
      }
    } else {


      if (
        window.scrollY + window.innerHeight <
        footerTop &&
        window.scrollY >
        this.mainAtc.getBoundingClientRect().bottom + window.scrollY
      ) {
        this.stickyAtcWrapper.setAttribute("aria-hidden", false);
      } else {
        this.stickyAtcWrapper.setAttribute("aria-hidden", true);
      }
    }
  }

  async handleComplementaryProducts() {
    this.block_options = JSON.parse(
      this.complementaryEl.getAttribute("data-block-settings")
    );
    let optionToUse = this.block_options.select_type;
    this.complementaryElWrapper = this.element.querySelector(
      ".complementary_products--wrapper"
    );

    let url = `${window.routes.recommended_products_url}?section_id=complementary_products_pdp&product_id=${this.options["product_id"]}&limit=10&intent=${optionToUse}`;

    const response = await fetch(url);
    if (!response.ok) throw new Error(response.status);
    let content = await response.text();
    content = new DOMParser().parseFromString(content, "text/html");
    let hasProducts;

    const contentToInsert = content.querySelector(
      ".complementaryProducts--section"
    );

    //Init swiper
    this.element
      .querySelector(".complementary_products--PdpSwiper")
      .appendChild(contentToInsert);
    this.carouselComplementary = this.element.querySelector(
      "#complementarySwiperElement"
    );
    if (this.carouselComplementary) {
      this.NewCarousel = new RevolutionSwiper(this.carouselComplementary);
    }

    this.childEl = this.element.querySelector(
      ".complementaryProducts--section .complementaryProducts--imageWrapper"
    );

    if (this.childEl) {
      hasProducts = true;
    } else {
      hasProducts = false;
    }
    if (this.complementaryElWrapper && hasProducts) {
      this.complementaryElWrapper.style.display = "block";
    }
  }

  changeImageQuality() {
    var imageToReveal = null;
    imageToReveal = this.element.querySelector(".ProductSlider--ImageFirst");
    if (imageToReveal !== null) {
      const replaceUrl = imageToReveal
        .getAttribute("data-src")
        .replace("{width}x", "2600x");
      imageToReveal.src = replaceUrl;
    }
  }
}
customElements.define("product-component", ProductElement);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.variants = this.element.querySelectorAll(".Selectbox");
    this.atcButtons = document.querySelectorAll(".ProductPage--ATC");
    this.notifyButtons = document.querySelectorAll(
      ".product-module__product-atc-notify"
    );

    this.notifyStickyAddButton = document.querySelector(
      ".product-module__product-atc"
    );
    this.productVariants_sticky = document.querySelector(
      ".product_sticky_variants"
    );
    if (this.productVariants_sticky) {
      this.productVariants_sticky.textContent =
        this.productVariants_sticky.textContent.replace(/\//g, "|");
    }

    this.regularPrice = document.querySelectorAll(
      "product-component .priceItem--regular"
    );
    this.compareAtPrice = document.querySelectorAll(
      "product-component .product-info__price--compare del"
    );

    this.pricesWrapper = document.querySelectorAll(
      "dd.priceCompare"
    );
    this.bindEvents();
    this.onVariantChange();
  }

  bindEvents() {
    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

    var selectboxes = this.element.querySelectorAll("select, input");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });
  }

  onQuantityChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
    this.updatePriceOnVariant();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
    this.updateVariantStatuses();

    this.updateURL();
    this.updatePriceOnVariant();
    this.updatePriceBlock();
    this.updateVariantInput();

    this.updateLowestPrice();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, input:checked"),
      (select) => select.value
    );
  }

  updateLowestPrice() {
    let allMetaVariants = document.querySelectorAll(".lowest-price-meta");
    const lowestPriceInput = document.querySelectorAll(
      ".product-info__price--lowest span"
    );


    allMetaVariants.forEach((meta) => {

      if (meta.getAttribute("data-variant_id") == this.currentVariant.id) {
        let lowestPrice = meta.getAttribute("meta-data");

        lowestPriceInput.forEach((input) => {
          input.innerHTML = Shopify.formatMoney(
            lowestPrice,
            window.theme.moneyFormat
          );
        });

        if (lowestPrice == 0) {
          lowestPriceInput.forEach((item) => {
            item.style.display = "none";
          });
        }
      }
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(`input:checked`).value === variant.option1
    );

    const inputWrappers = [...this.querySelectorAll(".VariantSelect")];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;

      const optionInputs = [...option.querySelectorAll(`input`)];

      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;

      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.closest(".Selectbox").classList.remove("variant-notify-me");
        input.parentElement.querySelector(".variant-out-of-stock").style.display = "none";
        input.removeAttribute("disabled-variant");
      } else {
        input.setAttribute("disabled-variant", "true");
        input.parentElement.querySelector(".variant-out-of-stock").style.display = "block";
        input.closest(".Selectbox").classList.add("variant-notify-me");
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }


  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updatePriceOnVariant() {
    this.element.dispatchEvent(
      new CustomEvent("price:change", {
        bubbles: true,
        detail: {
          eventName: "variant",
          price_raw: this.currentVariant.price,
          compare_at_price: this.currentVariant.compare_at_price,
        },
      })
    );
  }

  updatePriceBlock() {
    if (this.regularPrice && this.regularPrice.length) {
      this.regularPrice.forEach((regularPriceElement) => {
        if (this.currentVariant.price) {
          const regularPriceTag = this.currentVariant.price;
          regularPriceElement.innerHTML = Shopify.formatMoney(
            regularPriceTag,
            window.theme.moneyFormat
          );
        }
      });
    }

    if (this.compareAtPrice && this.compareAtPrice.length) {
      this.compareAtPrice.forEach((comparePriceElement) => {
        const compareAtPriceTag = this.currentVariant.compare_at_price;
        if (compareAtPriceTag) {
          comparePriceElement.innerHTML = Shopify.formatMoney(
            compareAtPriceTag,
            window.theme.moneyFormat
          );
        } else {
          comparePriceElement.innerText = "";
        }
      });
    } else if (this.currentVariant.compare_at_price && (!this.compareAtPrice || this.compareAtPrice.length === 0)) {
      const compareAtPriceTag = this.currentVariant.compare_at_price;

      if (this.pricesWrapper && this.pricesWrapper.length) {
        this.compareAtPrice = [];

        this.pricesWrapper.forEach((wrapper) => {
          const compareAtPriceDiv = document.createElement("span");
          const compareAtPriceDel = document.createElement("del");

          compareAtPriceDiv.className = "u-p2 product-info__price--compare";
          compareAtPriceDel.textContent = Shopify.formatMoney(
            compareAtPriceTag,
            window.theme.moneyFormat
          );

          compareAtPriceDiv.appendChild(compareAtPriceDel);
          wrapper.appendChild(compareAtPriceDiv);

          this.compareAtPrice.push(compareAtPriceDel);
        });
      }
    } else {
      if (this.compareAtPrice && this.compareAtPrice.length) {
        this.compareAtPrice.forEach((comparePriceElement) => {
          comparePriceElement.innerText = "";
        });
      }
    }
  }



  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  toggleAddButton() {
    let hideButtons = document.querySelectorAll(".hideBtn");
    hideButtons.forEach(function (button) {
      button.classList.remove("hideBtn");
    });
    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC");


    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    if (this.currentVariant.available == false) {
      addButton.classList.add("hideBtn");
    } else {
      addButton.classList.remove("hideBtn");
    }

    this.showNotifyMeButton(this.currentVariant.available);
  }

  showNotifyMeButton(available) {
    if (!this.notifyButtons) return;
    if (this.productVariants_sticky) {
      this.productVariants_sticky.textContent = this.currentVariant.title;
      this.productVariants_sticky.textContent =
        this.productVariants_sticky.textContent.replace(/\//g, "|");
    }
    if (available) {
      this.notifyButtons.forEach((btn) => (btn.style.display = "none"));
      this.atcButtons.forEach((btn) => (btn.style.display = "block"));
      if (this.notifyStickyAddButton) {
        this.notifyStickyAddButton.style.display = "block";
      }
    } else {
      this.notifyButtons.forEach((btn) => (btn.style.display = "flex"));
      this.atcButtons.forEach((btn) => (btn.style.display = "none"));
      if (this.notifyStickyAddButton) {
        this.notifyStickyAddButton.style.display = "none";
      }
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);

class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.searchInputElement = this.element.querySelector('[name="q"]');

    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    this.transitionElement = this.element.querySelector(".searchInnerWrapper");
    this.pageOverlayElement = this.element.querySelector(".sectionOverlay");
    this.searchBarWrapper = this.element.querySelector(".searchInput--Wrapper")
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.clearSearchButton = this.element.querySelector(".searchInput--clear");

    this.initCarouselInitial();
    this.headerTransparent = false;

    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchInputElement.offsetHeight + 48}px`
    );
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    this.bindEvents();
  }

  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateBody.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );

    this.searchInputElement.addEventListener("input", this._onInputListener);

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );
    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
  }

  initCarousel() {
    var carousel = this.searchResultsElement.querySelector(
      ".swiper__not-default"
    );
    if (carousel) {
      this.newCarousel = new RevolutionSwiper(carousel);

      const totalSlides = this.newCarousel.swiperElement.slides.length;
      const totalSlides2 = this.newCarousel.swiperElement.slides;

      totalSlides2.forEach(slide => {

        slide.classList.add('adjust-width');
      });
      const slidesPerView = this.newCarousel.swiperElement.params.slidesPerView;

      if (totalSlides < slidesPerView) {
        this.newCarousel.swiperElement.params.slidesOffsetAfter = 0;
        this.newCarousel.swiperElement.update();
      }
    }
  }

  initCarouselInitial() {
    this.carouselElement = this.element.querySelector(".searchInitialView");
    if (this.carouselElement) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.swiperBtn = this.carouselElement.querySelector(".search__all-collections-btn");
      this.swiperNavContainer = this.carouselElement.querySelector(".swiper-nav__wrapper--search");
      this.swiperNavContainer.style.width = "100%";
      this.swiperNavContainer.style.marginRight = "0";
      this.swiperBtn.style.display = "none";

      const totalSlides = this.carousel.swiperElement.slides.length;
      const slidesPerView = this.carousel.swiperElement.params.slidesPerView;

      if (totalSlides < slidesPerView) {
        this.carousel.swiperElement.params.slidesOffsetAfter = 0;
        this.carousel.swiperElement.update();
      }
    }
  }

  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  openSearch(event) {
    event.preventDefault();

    const _this = this;
    // Check if search is already open, close it if true
    if (this.isOpen) {
      this.closeSearch();
      return;
    }

    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );

    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );

    // Check if search element exists
    if (!this.element) {
      console.error("Search element not found");
      return;
    }
    this.element.style.display = 'block';
    // Show search element and page overlay
    const search = document.querySelector("#quickSearch");
    if (search) {
      requestAnimationFrame(() => {
        search.setAttribute("aria-hidden", false);
      });

    }
    this.pageOverlayElement.classList.add("is-visible");
    // Disable scrolling on body
    bodyScrollLock.disableBodyScroll(
      this.element.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );
    document.body.classList.add("scrollLock");

    // Focus on search input element after delay
    setTimeout(() => {
      if (_this.searchInputElement) {
        _this.searchInputElement.focus();
      }
    }, 200);

    setTimeout(() => {
      header.classList.remove("Header--Transparent");
      this.headerTransparent = true;
    }, 15);

    // Set isOpen to true
    this.isOpen = true;

    // Add event listener to page overlay to close search
    if (this.pageOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener("click", this.closeListener);
    }
  }

  closeSearch() {
    event.preventDefault();

    if (!this.isOpen) {
      return;
    }

    document.body.classList.remove("scrollLock");
    bodyScrollLock.enableBodyScroll(
      this.element.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );
    this.handleSearchCloseBinder = this.handleSearchClose.bind(this);

    this.element.addEventListener('transitionend', this.handleSearchCloseBinder);
    this.element.setAttribute("aria-hidden", true);

    this.pageOverlayElement.classList.remove("is-visible");

    this.isOpen = false;

    setTimeout(() => {
      this.resetSearch();
    }, 150);
  }

  handleSearchClose(e) {
    if (this.headerTransparent && this.headerTransparent) {
      document.body
        .querySelector("#header")
        .classList.add("Header--Transparent");
    }

    if (e.propertyName === 'opacity') {
      this.element.style.display = 'none';
    }

    this.element.removeEventListener('transitionend', this.handleSearchCloseBinder);
  }

  async fetchViewedProducts(viewedProducts) {
    this.allPredictiveSearchInstances = [];
    this.viewedProductsTitleLang = this.element.querySelector(".predictiveSearch--title-viewed-products");
    this.defaultCollection = this.element.querySelector(".predictiveSearch--products");
    this.defaultProductsTitle = this.element.querySelector(".predictiveSearch--title");

    try {
      // Construct the query string using the product IDs
      const query = viewedProducts.map(id => `id:${id}`).join(' OR ');

      // Fetch products using the search API
      const response = await fetch(`${window.routes.localeRootUrl}/search?view=recently&type=product&q=${encodeURIComponent(query)}`);

      if (!response.ok) {
        throw new Error(`Error fetching products: ${response.status}`);
      }

      //Parse the fetched HTML response
      const data = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");

      // Extract the relevant products
      const fetchedProducts = Array.from(doc.querySelectorAll(".search-product-item"));

      // Reorder the products to match the order of IDs in viewedProducts

      const reorderedProducts = viewedProducts.map(id =>
        fetchedProducts.find(product => parseInt(product.dataset.productId) === id)
      ).filter(product => product); // filter out any undefined products

      // Replace the content of the element with class name .searchInitialView__has-products--products
      const initialViewElement = this.searchResultsElement.querySelector(".searchInitialView__has-products--products");

      if (initialViewElement) {
        initialViewElement.innerHTML = ""; // Clear current content
        reorderedProducts.forEach(product => {
          initialViewElement.appendChild(product);
        });

        this.viewedProductsTitleLang.style.display = "block";
        this.defaultProductsTitle.style.display = "none";
        this.defaultCollection.classList.remove("search-default-collection");

        this.defaultCollectionSwiper = this.element.querySelector(".searchInitialView");
        this.defaultCollectionSwiperWithProducts = this.element.querySelector(".searchInitialView__has-products");
        this.defaultCollectionSwiper.style.display = "none";
        this.defaultCollectionSwiperWithProducts.style.display = "block";
        this.initCarousel();
        this.searchResultsElement.style.opacity = 1;
      }

    } catch (error) {
      console.error('Failed to fetch viewed products:', error);
    }
  }

  async onInput(event) {
    this.allPredictiveSearchInstances = [];
    this.lastInputValue = event.target.value;
    this.searchResultsElement.style.opacity = 0;

    this.clearSearchButton.setAttribute("aria-hidden", "false");
    if (event.target.getAttribute("data-value") && this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = this.element.querySelector(".searchInput");

      el.setAttribute("value", this.lastInputValue);
      el.value = this.lastInputValue;
    } else {
      if (this.lastInputValue === "") {
        this.resetSearch();
        return;
      }
    }

    try {
      const response = await fetch(
        `${routes.predictive_search_url}?q=${encodeURIComponent(
          this.lastInputValue
        )}&resources[limit_scope]=each&section_id=search-predictive`
      );

      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      const text = await response.text();
      const resultsMarkup = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector("#shopify-section-search-predictive").innerHTML;

      // Save bandwidth keeping the cache in all instances synced
      this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
        predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
      });
      const div = document.createElement("div");
      div.innerHTML = resultsMarkup;

      this.searchResultsElement.innerHTML = resultsMarkup;
      this.initCarousel();
      this.initCarouselInitial();
      this.searchResultsElement.style.opacity = 1;

    } catch (error) {
      if (error?.code === 20) {
        // Code 20 means the call was aborted
        return;
      }

      throw error;
    }
  }

  resetSearch() {
    const clonedLayout = this.initialSearchLayout.cloneNode(true);
    this.searchResultsElement.innerHTML = '';
    this.searchResultsElement.innerHTML = clonedLayout.innerHTML;
    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");
    this.searchInputElement.dataset.action = 'prevent-enter';

    this.initCarouselInitial();
    this.searchResultsElement.style.opacity = 1;
    this.searchInputElement.focus();
    this.clearSearchButton.setAttribute("aria-hidden", "true");
  }
}
customElements.define("search-bar", SearchBar);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".contacts__wrapper_button").removeAttribute("disabled");
    } else {
      this.element.querySelector(".contacts__wrapper_button").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-section", ContactSection);


class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-signup"]',
      this.clickOpen.bind(this)
    );
  }

  clickOpen() {
    this.options.delay = 0;
    this.openNewsletter();
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("popup-seen");

    if (this.options.show_only_once && localKey === "true") return;
    if (this.options.not_show_subscribed && this.options.is_subscribed) return;
    if (this.options.scroll_amount > 0) {
      document.addEventListener("scroll", this.scrollListener);
    } else {
      this.openNewsletter();
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter() {
    document.removeEventListener("scroll", this.scrollListener);
    setTimeout(() => {
      this.element.setAttribute("aria-hidden", false);
      this.pageOverlayElement.classList.add("is-visible");

      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
      document.body.classList.add("scrollLock");

      this.pageOverlayElement.addEventListener("click", this.closeNewsletter);

      localStorage.setItem("popup-seen", true);

      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeNewsletter
      );
    }, 1000 * this.options.delay);
  }

  closeNewsletter = () => {
    event.preventDefault();

    this.element.setAttribute("aria-hidden", true);
    this.pageOverlayElement.classList.remove("is-visible");
    document.body.classList.remove("scrollLock");
    bodyScrollLock.clearAllBodyScrollLocks();

    this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);

    document.removeEventListener("scroll", this.scrollListener);
  };
}

customElements.define("newsletter-popup", NewsletterPopup);
class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);


  }

  connectedCallback() {
    this.drawer = new Drawer(this.element.querySelector("#accountDrawer"), {
      onOpen: () => {
        const inputToFocus = this.element.querySelector("[aria-visible='true'] .input-placeholder--first");
        if (inputToFocus) {
          inputToFocus.setAttribute("readonly", "readonly");
          inputToFocus.focus();
          inputToFocus.removeAttribute("readonly");
        }
      }
    });

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on("click", '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on("click", '[data-action="submit-login"]', this.submitLogin.bind(this));
    this.delegateElement.on("click", '[data-action="submit-register"]', this.submitRegistration.bind(this));
    this.delegateElement.on("click", '[data-action="toggle-recovery"]', this.toggleRecovery.bind(this));
    this.delegateElement.on("click", '[data-action="submit-recovery"]', this.accountRecover.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-login"]', this.accountInputSubmit.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-reg"]', this.accountInputSubmitReg.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-forgot-pass"]', this.accountInputSubmitForgot.bind(this));
  }

  accountInputSubmit(e) {
    if (e.key === "Enter") this.submitLogin(e);
  }

  accountInputSubmitReg(e) {
    if (e.key === "Enter") this.submitRegistration(e);
  }

  accountInputSubmitForgot(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      this.accountRecover(e);
    }
  }

  async accountRecover(event) {
    event.preventDefault();
    const recoverEndpoint = `${window.routes.localeRootUrl}/account/recover`;
    const requestBody = {
      email: this.element.querySelector("#RecoverEmail").value,
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const buttonText = event.target.querySelector(".ButtonText");
    const loader = event.target.querySelector(".itemLoader");

    buttonText.style.visibility = "hidden";
    loader.classList.add("is-visible");

    try {
      const response = await fetch(recoverEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = responseText;
      const recoverError = this.element.querySelector("#recover .drawer__errors");
      const recoverSuccess = this.element.querySelector("#recover .account__form-success-msg");
      if (responseText.includes("account__recover-email-error")) {

        recoverSuccess.classList.remove("is-visible");
        recoverError.innerHTML = "";
        recoverError.innerHTML = tempDiv.querySelector("#account__recover-email-error").innerHTML;
        recoverError.classList.add("is-visible");
      } else if (responseText.includes("account__form-success-msg")) {

        recoverError.classList.remove("is-visible");
        recoverSuccess.innerHTML = "";
        recoverSuccess.innerHTML = tempDiv.querySelector("#account__form-success-msg").innerHTML;
        recoverSuccess.classList.add("is-visible");


      }

      buttonText.style.visibility = "visible";
      loader.classList.remove("is-visible");
    } catch (error) {
      console.error("An error occurred during the recovery request:", error);
    }
  }

  async submitRegistration(event) {
    event.preventDefault();
    const registrationEndpoint = `${window.routes.localeRootUrl}/account`;
    const requestBody = {
      customer: {
        first_name: this.element.querySelector("#RegisterForm-FirstName").value,
        last_name: this.element.querySelector("#RegisterForm-LastName").value,
        email: this.element.querySelector("#RegisterForm-email").value,
        password: this.element.querySelector("#RegisterForm-password").value,
      },
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const buttonText = event.target.querySelector(".ButtonText");
    const loader = event.target.querySelector(".itemLoader");

    buttonText.style.visibility = "hidden";
    loader.classList.add("is-visible");

    try {
      const response = await fetch(registrationEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();
      if (responseText.indexOf("registerErrors") !== -1) {
        console.error("Error occurred during registration.");
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;

        if (tempDiv.querySelector("#RegisterForm-email-error") !== -1) {
          this.element.querySelector("#RegisterForm-email-error").innerHTML = "";
          this.element.querySelector("#RegisterForm-email-error").innerHTML = '<span class="AlertErrorInner pt-l u-p4">' + tempDiv.querySelector("#RegisterForm-email-error").innerHTML + "</span>";
        }
        if (tempDiv.querySelector("#RegisterForm-password-error") !== -1) {
          this.element.querySelector("#RegisterForm-password-error").innerHTML = "";
          this.element.querySelector("#RegisterForm-password-error").innerHTML = '<span class="AlertErrorInner pt-l u-p4">' + tempDiv.querySelector("#RegisterForm-password-error").innerHTML + "</span>";
        }
      } else {
        location.href = window.routes.account_url;
      }

      buttonText.style.visibility = "visible";
      loader.classList.remove("is-visible");
    } catch (error) {
      console.error("An error occurred during the registration request:", error);
    }
  }

  async submitLogin(event) {
    event.preventDefault();
    const loginEndpoint = `${window.routes.localeRootUrl}/account/login`;
    const requestBody = {
      customer: {
        email: this.element.querySelector("#CustomerEmail").value,
        password: this.element.querySelector("#CustomerPassword").value,
      },
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const buttonText = event.target.querySelector(".ButtonText");
    const loader = event.target.querySelector(".itemLoader");

    buttonText.style.visibility = "hidden";
    loader.classList.add("is-visible");

    try {
      const response = await fetch(loginEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();

      if (responseText.includes("loginError")) {
        const loginError = this.element.querySelector("#login .drawer__errors");
        loginError.innerHTML = "";
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;
        loginError.innerHTML =
          tempDiv.querySelector(".AlertError").innerHTML;
        loginError.classList.add("is-visible");
      } else {
        location.href = window.routes.account_url;
      }

      buttonText.style.visibility = "visible";
      loader.classList.remove("is-visible");
    } catch (error) {
      console.error("An error occurred during the login request:", error);
    }
  }

  toggleTab(event) {
    event.preventDefault();
    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll(".accountDrawer--Tab");
    const allContent = this.element.querySelectorAll(".drawer__account-content");

    allTabs.forEach((tab) => tab.setAttribute("aria-expanded", "false"));
    allContent.forEach((content) => content.setAttribute("aria-visible", "false"));

    event.target.setAttribute("aria-expanded", "true");
    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute("aria-visible", "true");
    }
  }

  toggleRecovery(event) {
    event.preventDefault();
    const id = event.target.dataset.id;
    if (id === "recover") {
      this.element.querySelector("#recover").setAttribute("aria-visible", "true");
      this.element.querySelector("#login").setAttribute("aria-visible", "false");
      trapFocus(this.element.querySelector("#recover"));
    } else {
      this.element.querySelector("#recover").setAttribute("aria-visible", "false");
      this.element.querySelector("#login").setAttribute("aria-visible", "true");
      trapFocus(this.element.querySelector("#login"));
    }
  }
}

customElements.define("account-handler", AccountHandler);



class AnimatedAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    document.documentElement.style.setProperty(
      "--announcement-height-fixed",
      this.element.clientHeight + "px"
    );

    this.updateVisibleHeight();

    this.announcementItems = this.element.querySelectorAll('.annocement-bar__block');
    this.transitionSpeedSliding = this.element.getAttribute("data-settings");
    this.animWrapper = this.element.querySelector(
      ".announcement-bar--anim-wrapper"
    );
    this.original = this.element.querySelector(
      ".announcement-bar--duplicate-wrapper"
    );
    this.spaceDivWidth = 64;
    this.bindEvents();
    this.appearAnimation()
  }

  bindEvents() {
    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));
    this.element

    if (this.options["animationType"] === "sliding") {
      if (this.options["animationType"] === "sliding") {
        const debouncedFunc = debounce(this.handleBreakpointChange.bind(this), 100);
        responsive.addResizeListener(this, debouncedFunc);
        this.handleBreakpointChange();
      }

      if (this.element.dataset.main == "true") {
        window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
        responsive.addResizeListener(this, this.updateVisibleHeight.bind(this));
      }
    }
  }

  connectedCallback() {
    this.visibleHeightOld = this.element.clientHeight;
    this.visibleHeightFixed = this.element.clientHeight;
    document.documentElement.style.setProperty(
      "--announcement-height-fixed",
      this.element.clientHeight + "px"
    );
  }

  updateVisibleHeight() {

    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight =
      Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
    if (this.visibleHeightOld == visibleHeight) return;
    this.visibleHeightOld = visibleHeight;

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);
    // Update the height of .announcement-bar with the visible height
    document.documentElement.style.setProperty(
      "--announcement-dynamic-height",
      `${visibleHeight}px`
    );
  }

  handleBreakpointChange() {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.mobile = false;
      if (this.transitionSpeedSliding) {
        this.duplicateBlockWrappers();
      } else {
        Array.from(this.original.children).forEach(
          (block, i) => (block.style.display = "flex")
        );
        this.original.style.justifyContent = "space-between";
      }
    } else {
      this.mobile = true;
      if (this.transitionSpeedSliding) {
        this.duplicateBlockWrappers();
      } else {
        this.original.style.justifyContent = "center";
      }
    }
  }

  resetWrapper() {
    Array.from(this.animWrapper.children).forEach((child, i) => {
      if (i != 0) this.animWrapper.removeChild(this.animWrapper.lastChild);
    });
  }

  duplicateBlockWrappers() {
    this.resetWrapper();

    const duplicate = this.original.cloneNode(true);
    const originalWidth = this.original.offsetWidth;

    const wrapperWidth = this.mobile ? 2 * originalWidth + 64 : 2 * originalWidth;

    // Set wrapper width and position
    this.animWrapper.style.width = `${wrapperWidth}px`;
    this.animWrapper.style.position = "absolute";

    this.animWrapper.appendChild(this.original.cloneNode(true));
    this.animWrapper.appendChild(duplicate);
    this.element.style.height = `${this.animWrapper.offsetHeight}px`;

    setTimeout(() => {
      this.startAnimating(wrapperWidth);
    }, 100);
  }

  startAnimating(wrapperWidth) {
    let totalWidth = this.mobile ? wrapperWidth + 64 : wrapperWidth;

    const translateStart = 0;
    const translateEnd = -totalWidth / 2;

    this.animWrapper.style.transform = `translateX(${translateStart}px)`;

    const animation = this.animWrapper.animate(
      [
        { transform: `translateX(${translateStart}px)` },
        { transform: `translateX(${translateEnd}px)` },
      ],
      {
        duration: parseInt(this.transitionSpeedSliding) * 1000,
        iterations: Infinity,
        easing: "linear",
      }
    );

    this.element.addEventListener("mouseenter", () => animation.pause());
    this.element.addEventListener("mouseleave", () => animation.play());
  }

  initialize() {
    this.currentIndex = 0;
    this.announcementItems[this.currentIndex].classList.add('active');
    setInterval(this.showNextElement.bind(this), this.options["cycleSpeed"]);
  }

  showNextElement() {
    let previousIndex = this.currentIndex;
    this.announcementItems[previousIndex].classList.remove('active');
    this.announcementItems[previousIndex].classList.add('exit');

    this.currentIndex = (this.currentIndex + 1) % this.announcementItems.length;

    setTimeout(() => {
      this.announcementItems[previousIndex].classList.remove('exit');
      this.announcementItems[this.currentIndex].classList.add('active');
    }, this.options["transitionSpeedAppear"]);
  }

  appearAnimation() {
    if (this.options["animationType"] === "appear" && this.options["enableAnimation"]) {
      this.initialize();
    }
    if (this.options["animationType"] === "appear" && !this.options["enableAnimation"]) {
      const announcementItems = this.element.querySelectorAll(".annocement-bar__block");
      const announcementBarWrapper = this.element.querySelector(".announcement-bar--duplicate-wrapper");
      announcementItems.forEach((item) => {
        item.style.opacity = 1;
        item.style.position = "relative";
        item.style.padding = "0rem";
      });
      announcementBarWrapper.style.justifyContent = "space-between";
      announcementBarWrapper.style.width = "100%";
    }
  }
}
customElements.define("announcement-bar", AnimatedAnnouncementBar);



class QuoteSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define("quote-slider", QuoteSlider);

class NotifyMe extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.allNotifications = this.element.querySelectorAll(
      ".product-module__notify-action"
    );
    this.emailContainer = this.element.querySelector(
      "#product-module__notify-me-input"
    );
    this.subtitle = this.element.querySelector(".product-module__notify-text");
    this.productId = document.querySelector(
      'form[data-product-form] [name="id"]'
    ).dataset.productid;

    this.variantId = document.querySelector(
      '[name="notify_variant"]'
    ).dataset.id;
    this.initialState();
    this.bindEvents();
  }

  bindEvents() {
    this.onClickOutsideListener = this.closeNotifyMe.bind(this);

    this.delegateBody.on(
      "click",
      '[data-action="notify-open"]',
      this.openNotifyMe.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="subscribe"]',
      this.handleSubscribe.bind(this)
    );
    this.delegateBody.on("notify:change", this.updateVariantId.bind(this));
    this.delegateElement.on(
      "click",
      '[data-action="notify-close"]',
      this.closeNotifyMe.bind(this)
    );

    this.delegateElement.on('change', 'input[data-state="required"]', this.updateButtonState.bind(this));
  }

  updateButtonState() {
    if (event.target.checked) {
      this.element.querySelector('.product-module__notify-button').removeAttribute('disabled');
    } else {
      this.element.querySelector('.product-module__notify-button').setAttribute('disabled', true);
    }
  }

  initialState() {
    if (this.element.querySelector('[data-state="required"]')) {
      this.element.querySelector('.product-module__notify-button').setAttribute('disabled', true);
    } else {
      this.element.querySelector('.product-module__notify-button').removeAttribute('disabled');
    }
  }

  updateVariantId(e) {
    this.variantId = e.detail.id;
  }

  handleSubscribe() {
    const email = this.element.querySelector('[name="notify_email"]').value;
    let promise = SI.create(email, this.variantId, this.productId);

    if (email !== "" && email.includes("@")) {
      promise.then((st, data) => {
        let resp = SI.parseJSON(data);
        if (resp.status == "OK") {
          this.showNotification("success");
        } else {
          this.showNotification("error");
        }
      });
    } else {
      this.showNotification("email-error");
    }
  }

  clearNotifications() {
    this.allNotifications.forEach((el) =>
      el.setAttribute("aria-hidden", "true")
    );
  }

  showNotification(string) {
    this.clearNotifications();

    let activeNotification;
    switch (string) {
      case "success":
        activeNotification = this.element.querySelector(
          ".product-module__notify-action--success"
        );
        let defaultContainer = this.element.querySelector(
          ".product-module__notify-actions"
        );
        defaultContainer.style.display = "none";
        activeNotification.setAttribute("aria-hidden", "false");
        break;

      case "email-error":
        activeNotification = this.element.querySelector(
          ".product-module__notify-action--email-error"
        );
        break;

      default:
        activeNotification = this.element.querySelector(
          ".product-module__notify-action--error"
        );
        break;
    }

    activeNotification.setAttribute("aria-hidden", "false");
  }

  openNotifyMe(e) {
    e.preventDefault();
    this.element.setAttribute("aria-hidden", "false");
    trapFocus(this.element);

    this.pageOverlayElement.classList.add("is-visible");
    bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");

    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
  }

  closeNotifyMe(e) {
    this.element.setAttribute("aria-hidden", "true");

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );

    // Remove scrolllock and clear notifications after the popup disappears so there are no visible layout shifts
    this.element.addEventListener(
      "transitionend",
      () => {
        if (e.target.closest('[data-action="notify-close"]')) {
          setTimeout(() => {
            document.body.classList.remove("scrollLock");
            bodyScrollLock.enableBodyScroll(
              this.element,
              bodyScrollLockOptions
            );
            this.clearNotifications();
          }, 50);
        } else {
          document.body.classList.remove("scrollLock");
          bodyScrollLock.enableBodyScroll(this.element, bodyScrollLockOptions);
          this.clearNotifications();
        }
      },
      { once: true }
    );
  }
}

customElements.define("notify-me-popup", NotifyMe);
class UspSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = null;
    this.initSwiper()
  }

  initSwiper() {
    if (!new Responsive().matchesBreakpoint("lap_and_up")) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }
}
customElements.define("usp-section", UspSection);

class LegalSwiper extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!new Responsive().matchesBreakpoint("lap_and_up")) {
      this.carouselElement = this.element.querySelector(".swiper");
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }
}

customElements.define("legal-swiper", LegalSwiper);

class faqSection extends HTMLElement {
  constructor() {
    super();

    // Initialize elements and delegates
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.clicked = false;


    // Initialize the Swiper carousel
    if (this.element.querySelector("[data-swiper-settings]") && !responsive.matchesBreakpoint("lap_and_up")) {
      this.carousel = new RevolutionSwiper(
        this.element.querySelector("[data-swiper-settings]")
      );
      window.carousel = this.carousel;
    }


    // Remove padding from the second child title
    const parentDiv = document.querySelector(".FAQ");
    if (parentDiv) {
      const secondChild = parentDiv.children[1];
      if (secondChild) secondChild.style.paddingTop = "0";
    }

    // Bind events to the elements
    this.bindEvents();
    this.handleScroll();
  }

  // Method to bind events
  bindEvents() {
    this.handleScrollListener = this.handleScroll.bind(this);
    window.addEventListener("scroll", this.handleScrollListener);
    this.delegateElement.on(
      "click",
      '[data-action="handle-click"]',
      this.handleClick.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-search"]',
      this.clearSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-search-d"]',
      this.clearSearchDesktop.bind(this)
    );
    this.delegateElement.on(
      "keyup",
      '[data-action="search-string"]',
      this.handleSearch.bind(this)
    );
  }

  // Method to handle inserting text in input field
  insertInInput(event, target) {
    const inputEl = this.element.querySelector(".faq--search.mobile");
    if (inputEl) {
      inputEl.value = event.target.textContent;
    }
  }

  // Method to handle search functionality
  handleSearch(event) {
    const allTitles = this.element.querySelectorAll(".faq-subheader_title");
    allTitles.forEach((title) => {
      title.style.display = "block";
    });

    const firstTitle = this.element.querySelector(".FAQSubheader--firstTitle");
    if (firstTitle) {
      firstTitle.classList.remove("FAQSubheader--firstTitle");
    }

    // Mobile clear button handling
    const clearBtn = this.element.querySelector(
      ".clearSearch.supportFaq--mobileClearBtn"
    );
    const inputValue = this.element.querySelector(".faq--search.mobile").value;
    clearBtn.style.display = inputValue ? "flex" : "none";

    const noneTerms = this.querySelectorAll(".noTerms");
    noneTerms.forEach((el) => (el.textContent = `"${inputValue}"`));

    this.quickSearch(inputValue);
  }

  // Method to perform quick search
  quickSearch(inputSearch) {
    const allSections = this.element.querySelectorAll(".Faq-Section");
    allSections.forEach((title) => {
      title.style.display = "block";
    });

    inputSearch = inputSearch.toLowerCase();
    const divContainers = this.querySelectorAll(".faq-terms");

    divContainers.forEach((container) => {
      const containerText = container.textContent.toLowerCase();
      const matches = containerText.includes(inputSearch);

      container.classList.toggle("supportFaq--showed", matches);
      const faqSection = container.closest(".Faq-Section");
      const hasShownSubheader =
        faqSection &&
        faqSection.querySelector(".faq-subheader_title.supportFaq--showed");

      if (matches || hasShownSubheader) {
        container.style.display = "block";
      } else {
        container.style.display = "none";
      }
    });

    this.handleTitles();
    this.handleNoResults(divContainers);
  }

  // Method to handle title visibility
  handleTitles() {
    const allTitles = this.element.querySelectorAll(".faq-subheader_title");
    let firstTitle = true;

    allTitles.forEach((title) => {
      const parent = title.closest(".Faq-Section");
      const showed = parent.querySelector(".supportFaq--showed");


      title.style.display = showed ? "block" : "none";

      if (!showed) {
        parent.style.display = "none";
      }

      if (showed && firstTitle) {
        parent.classList.add("FAQSubheader--firstTitle");
        firstTitle = false;
      }
    });
  }

  // Method to handle "no results" text visibility
  handleNoResults(containers) {
    const noResults = ![...containers].some((container) =>
      container.classList.contains("supportFaq--showed")
    );
    const noResEl = this.querySelectorAll(".faq-no_results_text");

    noResEl.forEach((item) => {
      item.style.display = noResults ? "flex" : "none";
      item.classList.toggle("noResult--showed", noResults);
    });
  }

  // Method to clear mobile search input
  clearSearch() {
    const clearBtn = this.element.querySelector(
      ".clearSearch.supportFaq--mobileClearBtn"
    );
    const inputValue = this.element.querySelector(".faq--search.mobile");
    const noResEl = this.element.querySelector(".faq-no_results_text");

    if (inputValue) {
      inputValue.value = "";
      inputValue.focus(); // Bring focus to the input field
    }
    if (clearBtn) clearBtn.style.display = "none";
    if (noResEl) noResEl.style.display = "none";

    const allSections = this.element.querySelectorAll(".Faq-Section");
    allSections.forEach((title) => {
      title.style.display = "block";
    });

    const allTitles = this.element.querySelectorAll(".faq-subheader_title");
    allTitles.forEach((title) => {
      title.style.display = "block";
    });

    const firstTitle = this.element.querySelector(".FAQSubheader--firstTitle");
    if (firstTitle) firstTitle.classList.remove("FAQSubheader--firstTitle");

    this.quickSearch("");
  }

  // Method to clear desktop search input
  clearSearchDesktop() {
    const clearBtn = this.element.querySelector(
      ".clearSearch.supportFaq--desktopClearBtn"
    );
    const inputValue = this.element.querySelector(".faq--search.desktop");

    if (inputValue) inputValue.value = "";
    if (clearBtn) clearBtn.style.display = "none";

    const allTitles = this.element.querySelectorAll(".faq-subheader_title");
    allTitles.forEach((title) => {
      title.style.display = "block";
    });

    const firstTitle = this.element.querySelector(".FAQSubheader--firstTitle");
    if (firstTitle) firstTitle.classList.remove("FAQSubheader--firstTitle");

    this.quickSearch("");
  }

  // Method to handle click events
  handleClick(event) {
    this.element.dataset.clicked = "true";
    const allLinks = this.element.querySelectorAll(".faq-link_list_item");
    allLinks.forEach((item) => {
      item.classList.remove("current_link-page");
    });
    event.target.classList.add("current_link-page");
    setTimeout(() => {
      this.element.dataset.clicked = "false";
    }, 400);
  }

  // Method to remove all link highlights
  removeAllLinks() {
    const linkedItems = this.element.querySelectorAll(".current_link-page");
    linkedItems.forEach((item) => {
      item.classList.remove("current_link-page");
    });
  }

  // Method to initialize the scroll observer
  initObserver() {
    window.addEventListener("scroll", this.handleScrollListener);
  }

  // Method to handle scroll events
  handleScroll() {
    if (this.element.dataset.clicked === "true") return;
    const faqSubheaders = this.element.querySelectorAll(".faq-subheader_main");
    const faqMenuTabsWrapper = this.element.querySelectorAll(
      ".faq--menu_tabs_wrapper"
    );
    const threshold = 200;

    if (new Responsive().matchesBreakpoint("pocket")) {
      faqMenuTabsWrapper.forEach((item) => {
        const distanceFromTop = item.getBoundingClientRect().top;
        item.style.boxShadow =
          distanceFromTop <= 52 && distanceFromTop > 0
            ? "0px 4px 12px 0px rgba(20, 20, 20, 0.10)"
            : "none";
      });
    }

    faqSubheaders.forEach((faqSubheader) => {
      const distanceFromTop = Math.max(
        0,
        faqSubheader.getBoundingClientRect().top
      );
      if (distanceFromTop <= threshold && distanceFromTop > 0) {
        this.removeAllLinks();
        const faqSection = faqSubheader.closest(".Faq-Section").id;
        const anchorElements = this.element.querySelectorAll(
          `a[href="#${faqSection}"]`
        );

        anchorElements.forEach((item) => {
          item.classList.add("current_link-page");
          if (
            new Responsive().matchesBreakpoint("pocket") &&
            !item.classList.contains("swiper-slide-active")
          ) {
            this.carousel.swiperElement.slideTo(parseInt(item.dataset.index));
          }
        });
      }
    });
  }
}

customElements.define("faq-section", faqSection);

class FAQContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

  }

  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });

    if (this.buttonState == true) {
      this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
    } else {
      this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-faq", FAQContactSection);

function replaceBreadcrumbsText() {
  const breadcrumbs = document.querySelectorAll(".breadcrumbs__list");
  breadcrumbs.forEach((breadcrumb) => {
    breadcrumb.classList.remove("breadcrumbs__list--cut");

    if (breadcrumb.scrollWidth > breadcrumb.clientWidth) {
      breadcrumb.classList.add("breadcrumbs__list--cut");
    }
  });
}

window.addEventListener("load", replaceBreadcrumbsText);
responsive.addResizeListener(this, replaceBreadcrumbsText);

class MainSearch extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.filterBar = this.element.querySelector(".collection__nav-filter-bar");
    this.toggleButtons = this.element.querySelector(
      ".main-search__toggle-buttons"
    );

    this.initialize();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",

      '[data-action="toggle-collection"]',
      this.toggleGrid.bind(this)
    );
  }

  initialize() {
    const searchTypes = [
      { id: "collection__main-grid-articles", type: "article" },
    ];

    searchTypes.forEach(({ id, type }) => this.fetchSearchType(id, type));
  }

  fetchSearchType(gridContainerId, type) {
    const section = document.getElementById(gridContainerId);
    if (!section) return;

    const sectionId = section.dataset.id;
    const searchTerms = this.element.dataset.searchTerms;
    const url = `${window.location.pathname}?section_id=${sectionId}&${searchTerms}&type=${type}`;

    this.renderSectionFromFetch(url, gridContainerId, section, type);
  }

  async renderSectionFromFetch(url, gridContainerId, gridContainer, type) {
    try {
      const response = await fetch(url);
      const html = await response.text();

      this.renderGrid(html, gridContainerId, gridContainer, type);
    } catch (error) {
      console.error("Error fetching section:", error);
    }
  }

  renderGrid(html, gridContainerId, gridContainer, type) {
    const newGridContent = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById(gridContainerId);
    if (!newGridContent) return;
    this.updateResultCount(newGridContent, type);
    gridContainer.parentElement.innerHTML = newGridContent.outerHTML;
  }

  updateResultCount(newGridContent, type) {
    this.toggleButtons.setAttribute("aria-hidden", false);
    const count = newGridContent.dataset.results;
    const resultElement = this.element.querySelector(
      `[aria-controls="collection-${type}"] span`
    );

    if (resultElement) {
      count > 0
        ? (resultElement.innerHTML = newGridContent.dataset.results)
        : (resultElement.disabled = true);
    }
  }

  toggleGrid(e) {
    const target = e.target.closest('[data-action="toggle-collection"]');
    const id = target.getAttribute("aria-controls");

    if (this.filterBar) {
      id.includes("product")
        ? this.filterBar.setAttribute("aria-hidden", "false")
        : this.filterBar.setAttribute("aria-hidden", "true");
    }

    const gridToHide = this.element.querySelector(
      'main-collection-grid[aria-hidden="false"]'
    );
    const gridToShow = this.element.querySelector(`#${id}`);
    const prevActiveButton = this.element.querySelector(
      '[data-action="toggle-collection"][aria-expanded="true"]'
    );

    gridToHide.setAttribute("aria-hidden", "true");
    gridToShow.setAttribute("aria-hidden", "false");

    prevActiveButton.setAttribute("aria-expanded", "false");
    target.setAttribute("aria-expanded", "true");
  }
}
customElements.define("search-component", MainSearch);

class CommentSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.whireCommentBtn = this.element.querySelector(".Comments--WhireButton");
    this.revealWrapper = this.element.querySelector(".Comments--RevealWrapper");
    this.currentPageKey = this.extractStringFromURL(window.location.href);
    this.openedCom = this.querySelector(".show-comments");
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.articleWrapper = this.element.querySelector(
      ".Comments--ArticleWrapper"
    );

    const swiper = new Swiper(".ArticleComments", {
      // Default parameters
      slidesPerView: 1,

      grid: {
        rows: 3, // your amount of slides
        fill: "row",
      },
      spaceBetween: 0,
      pagination: {
        el: "#blog_comments_swiper-pagination",
        type: "bullets",
        clickable: true,
        bulletClass: "comments-section__swiper-pagination-bullet",
        bulletActiveClass: "comments-section__swiper-pagination-bullet--active",
        dynamicMainBullets: 3,
      },
      navigation: {
        nextEl: ".nextEl",
        prevEl: ".prevEl",
      },
      mousewheel: {
        forceToAxis: true,
      },
      loop: false,

      breakpoints: {
        1025: {
          slidesPerView: 1,

          grid: {
            rows: 3,
          },
          spaceBetween: 0,
        },
      },
    });

    if (this.articleWrapper)
      this.allChildren = Array.from(this.articleWrapper.children);
    this.paginationWrapper = this.element.querySelector(".pagination__wrapper");

    const beenHere = sessionStorage.getItem("postRequest");
    if (beenHere == this.currentPageKey) {
      this.revealWrapper.style.height = "fit-content";
      this.whireCommentBtn.style.display = "none";
    }

    this.mobile = new Responsive().matchesBreakpoint;
    this.toggleButton();
    this.bindListeners();
  }

  bindListeners() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

    this.textArea = this.element.querySelector("#CommentForm-body");
    const formListener = this.element.querySelector("#comment_form");
    if (formListener) {
      formListener.addEventListener("submit", this.verifyForm.bind(this));
    }
  }

  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });


    if (this.buttonState == true) {
      this.element
        .querySelector(".Comments--SendButton .Button")
        .removeAttribute("disabled");
    } else {
      this.element
        .querySelector(".Comments--SendButton .Button")
        .setAttribute("disabled", true);
    }
  }

  verifyForm(e) {
    const requiredCheckboxes = document.querySelectorAll(
      "input.Comments--Required"
    );
    const uncheckedCheckboxes = [];

    requiredCheckboxes.forEach((checkbox) => {
      if (!checkbox.checked) {
        e.preventDefault();
        uncheckedCheckboxes.push(checkbox);
      }
    });

    if (uncheckedCheckboxes.length > 0) {
      uncheckedCheckboxes.forEach((checkbox) => {
        const errorMessageElement = checkbox.parentElement
          .querySelector(`label[for=${checkbox.id}]`)
          ?.querySelector(".Comments--ErrorMessage");
        if (errorMessageElement)
          errorMessageElement.classList.add("showCommentErrorMsg");
      });
    } else {
      if (this.currentPageKey.includes("#comment_form")) {
        sessionStorage.setItem("postRequest", this.currentPageKey);
      } else {
        sessionStorage.setItem(
          "postRequest",
          this.currentPageKey + "#comment_form"
        );
      }
    }
  }

  extractStringFromURL(url) {
    const parts = url.split("/");
    return parts[parts.length - 1];
  }
}
customElements.define("comment-section", CommentSection);

class BlogSection extends HTMLElement {
  constructor() {
    super();

    this.element = this;
    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.carousel = new RevolutionSwiper(
      this.carouselElement
    );
  }
}
customElements.define("blog-section", BlogSection);

class BlogShowcaseSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".blog_showcase_swiper ");
    this.carousel = new RevolutionSwiper(this.carouselElement);
    this.delegateElement = new Delegate(this.element);
    this.carouselElementTags = this.element.querySelector(
      ".blog_showcase_tags_swiper"
    );
    this.carouselTags = new RevolutionSwiper(this.carouselElementTags);
    this.shown_tags = this.element.querySelectorAll(".blogshowcase_tag");
    this.view_all_button = this.element.querySelector(
      ".blog_showcase_button_wrapper"
    );

    const initial_selected_tag = this.shown_tags[0];
    const initial_selected_tag_selected =
      initial_selected_tag.getAttribute("data-value");
    let view_all_link = this.view_all_button.getAttribute("data-link");
    this.view_all_button
      .querySelector("a")
      .setAttribute(
        "href",
        "blogs/" +
        `${view_all_link}` +
        "/tagged/" +
        `${initial_selected_tag_selected}`
      );
    this.toggleTags(event, initial_selected_tag);
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-tags"]',
      this.toggleTags.bind(this)
    );
  }

  toggleTags(event, target) {
    this.shown_tags.forEach((tag) => {
      tag.setAttribute("tag-status", "not-selected");
    });
    target.setAttribute("tag-status", "selected");

    const selected_tag = target.getAttribute("data-value");
    let articles = this.element.querySelectorAll(".blog-article");
    articles.forEach((article) => {
      let article_link = article.querySelector("a");
      let blog_tags = article_link.getAttribute("data-tag");
      let blog_tags_array = blog_tags.split(";");

      if (blog_tags_array.includes(selected_tag)) {
        article.style.display = "block";
      } else if (!blog_tags_array.includes(selected_tag)) {
        article.style.display = "none";

      }
    });

    let view_all_link = this.view_all_button.getAttribute("data-link");
    this.view_all_button
      .querySelector("a")
      .setAttribute(
        "href",
        "blogs/" + `${view_all_link}` + "/tagged/" + `${selected_tag}`
      );
  }
}
customElements.define("blog-showcase", BlogShowcaseSlider);


class dynamicVariables {
  constructor() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );

    responsive.addResizeListener(this, this.sync.bind(this));
  }

  sync() {
    this.syncWidth();
    this.syncHeight();
  }

  syncWidth() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  }
}

const dynamicVars = new dynamicVariables();


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    this.element = this;
    new RevolutionSwiper(this.querySelector('.swiper'));

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            new RevolutionAnimation(this.element);
            if (this.element.querySelector('.product-recommendations__cell')) {
              new RevolutionSwiper(this.querySelector('.swiper'));
              this.element.style.visibility = 'visible';
            } else {
              this.element.closest('.shopify-section').remove();
            }

          }

        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '-100px 0px 200px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class CardPopUpContent extends HTMLElement {
  constructor() {
    super();
    this.delegateElement = new Delegate(this);
    this.domDelegate = new Delegate(document.body);
    this.clonedContent = null;
    new AddToCart(this);
    new Drawer(this);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.bindEvents();
  }

  bindEvents() {
    this.domDelegate.on(
      "product-card-drawer:open",
      this.replaceContent.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='change-price']",
      this.changeData.bind(this)
    );

  }

  replaceContent(e) {
    const productId = e.detail.product;
    const contentToInsert = document.body.querySelector(`.product-popup__inner-content[data-product-id="${productId}"]:not(.copy)`);
    const freshClone = contentToInsert.cloneNode(true);
    freshClone.classList.add("copy");

    const contentToReplace = this.querySelector(".product-card__popup-scrollable-content");
    contentToReplace.innerHTML = "";
    contentToReplace.appendChild(freshClone);
    contentToReplace.classList.add("mobile__popup-scrollable-content");
    contentToReplace.querySelectorAll(".inputSelectboxCheckbox").forEach((input) => (input.checked = false));
    const btn = contentToReplace.querySelector(".ProductCard--instantATC-popup");
    if (btn) btn.disabled = true;
  }

  changeData(event) {
    this.querySelectorAll(".inputSelectboxCheckbox").forEach((input) => (input.checked = false));
    event.target.checked = true;
    const { price, comparePrice, available, variantId } = event.target.dataset;
    const priceDisplay = this.querySelector(".priceItem");
    const comparePriceDisplay = this.querySelector(".compare_change");
    if (priceDisplay) priceDisplay.textContent = price;
    if (comparePrice && available === "true") {
      priceDisplay.classList.add("price--lower-alert")
    } else if (comparePrice && available === "false") {
      priceDisplay.classList.add("price--unavailable")
      comparePriceDisplay.classList.add("price--unavailable")
    } else {
      priceDisplay.classList.remove("price--lower-alert")
      priceDisplay.classList.remove("price--unavailable")
      comparePriceDisplay.classList.remove("price--unavailable")
    }


    if (comparePriceDisplay) comparePriceDisplay.textContent = comparePrice;

    const comparePriceContainer = this.querySelector(".priceCompare");
    if (comparePriceContainer) comparePriceContainer.classList.remove("hidden");

    const btn = this.querySelector(".ProductCard--instantATC-popup");
    if (btn) btn.disabled = available === "false";

    const productForm = this.querySelector(".shopify-product-form");
    if (productForm) {
      productForm.dataset.productid = variantId;
      const input = productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = variantId;
        input.dataset.id = variantId;
        input.dataset.productid = variantId;
      }
    }
  }

}

customElements.define("mobile-product-card", CardPopUpContent);

class CollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    // Ensure the DOM is fully loaded before initializing
    requestAnimationFrame(() => {
      this.carouselElement = this.element;
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.bindEvents();
    });
  }

  bindEvents() {

  }

}
customElements.define("collection-tabs", CollectionTabs);


class InfiniteScroll {
  constructor(container, paginationElement, restoreState) {

    if (
      !document.querySelector(container) ||
      !document.querySelector(paginationElement)
    )
      return;


    this.containerSelector = container;
    this.paginationElementSelector = paginationElement;
    this.restoreState = restoreState;
    this.treshold = 650;
    this.domDelegate = new Delegate(document.body);
    this.mainContainer = document.querySelector(this.containerSelector);
    this.loadType = this.mainContainer.dataset.load;
    this.running = false;
    this.bindEvents();

    const pageAccessedByReload =
      (window.performance.navigation &&
        window.performance.navigation.type === 1) ||
      window.performance
        .getEntriesByType("navigation")
        .map((nav) => nav.type)
        .includes("reload");

    if (
      this.restoreState &&
      sessionStorage.getItem("pageState") > 1 &&
      window.location.href === sessionStorage.getItem("pageStateURL") &&
      !pageAccessedByReload
    ) {
      const promises = this.generateFetchPromises(false);
      this.renderData(promises, true);
    } else {
      this.initObserver();
    }
  }

  initObserver() {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    };

    this.observer = new IntersectionObserver(
      this.handleIntersect.bind(this),
      observerOptions
    );
    this.observer.observe(this.mainContainer);
  }

  bindEvents() {
    this.handleClickBinder = this.handleClick.bind(this);
    this.handleScrollBinder = this.handleScroll.bind(this);



    if (this.restoreState) {
      window.addEventListener(
        "beforeunload",
        this.rememberCurrentState.bind(this)
      );
    }
  }

  rememberCurrentState() {
    const scrollPositionY = window.scrollY;
    const currentUrl = window.location.href;
    const currentPage = document.querySelector(this.paginationElementSelector)?.dataset.page;

    sessionStorage.setItem("pageState", currentPage);
    sessionStorage.setItem("pageStateURL", currentUrl);
    sessionStorage.setItem("pageStateScroll", scrollPositionY);
  }

  initialize() {
    if (this.loadType === "scroll") {
      window.addEventListener("scroll", this.handleScrollBinder);
    } else {

      this.domDelegate.on(
        "click",
        `${this.paginationElementSelector} [data-action="load"]`,
        this.handleClickBinder
      );
    }
  }

  destroy() {
    if (this.loadType === "scroll") {
      window.removeEventListener("scroll", this.handleScrollBinder);
    } else {
      this.domDelegate.off(
        "click",
        `${this.paginationElementSelector} [data-action="load"]`,
        this.handleClickBinder
      );
    }
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (this.running === false) {
          this.initialize();
          this.running = true;
        }
      } else {
        this.running = false;
        this.destroy();
      }
    });
  }

  handleScroll() {
    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (!this.paginationElement) return;

    const top =
      this.paginationElement.getBoundingClientRect().top - this.treshold;
    const bottom =
      this.paginationElement.getBoundingClientRect().bottom + this.treshold;

    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement.querySelector("a");

      if (this.nextPageLinkElement) {
        this.destroy();
        const nextPageUrl = this.nextPageLinkElement.href;
        const promises = this.generateFetchPromises(nextPageUrl);
        this.renderData(promises);
      }
    }
  }

  handleClick(e) {
    e.preventDefault();
    e.target
      .closest("a")
      .querySelector(".itemLoader")
      .classList.add("is-visible");

    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );


    if (!this.paginationElement) return;
    this.nextPageLinkElement = this.paginationElement.querySelector("a");

    if (this.nextPageLinkElement) {
      this.destroy();
      const nextPageUrl = this.nextPageLinkElement.href;
      const promises = this.generateFetchPromises(nextPageUrl);
      this.renderData(promises);
    }
  }

  generateFetchPromises(nextPageUrl) {
    const promises = [];

    if (nextPageUrl == false) {
      const hasSearchParameters = window.location.search.length > 0;
      const limit = parseInt(sessionStorage.getItem("pageState"));
      for (let i = 2; i <= limit; i++) {
        let url;

        // Build the URL based on the condition
        if (hasSearchParameters) {
          url = `${window.location.href}&page=${i}`;
        } else {
          url = `${window.location.href}?page=${i}`;
        }

        promises.push(
          fetch(url, {
            credentials: "same-origin",
            method: "GET",
          })
        );
      }
    } else {
      const url = `${nextPageUrl}`;

      promises.push(
        fetch(url, {
          credentials: "same-origin",
          method: "GET",
        })
      );
    }

    return promises;
  }

  async renderData(promises, restoreContent) {


    try {
      const responses = await Promise.all(promises);
      const contents = await Promise.all(
        responses.map((response) => response.text())
      );
      let isLastPromise = false;
      contents.forEach((content, index) => {
        isLastPromise = index === contents.length - 1;

        this.appendContent(content, isLastPromise, restoreContent);
      });
    } catch (error) {
      console.error("Error fetching or parsing data:", error);
    }
  }

  appendContent(content, lastPromise, restoreContent) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");
    const contentToAdd = doc.querySelector(this.containerSelector);

    this.mainContainer = document.querySelector(this.containerSelector);
    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (this.paginationElement) {
      this.paginationElement.remove();
    }

    this.mainContainer.insertAdjacentHTML("beforeend", contentToAdd.innerHTML);

    if (lastPromise) {
      this.initialize();
    }

    if (lastPromise && restoreContent) {
      this.restoreScroll();
    }

    document.dispatchEvent(
      new CustomEvent("pagination:finished", { bubbles: true })
    );

    new RevolutionAnimation(this.mainContainer);
  }

  restoreScroll() {
    const scrollPosition = parseInt(sessionStorage.getItem("pageStateScroll"));

    if (scrollPosition) {
      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  }
}